/**
 * Pure Serre — Product gallery autoplay
 * Advances the product media slideshow every 5 seconds.
 * Pauses on hover / touch and when the page is not visible.
 */

/* =====================================================
   product-collection-bg height — ajuste la hauteur du
   bandeau image selon le nombre de lignes du h1 (desktop only)
   +44px par ligne au-delà de 1
   ===================================================== */
(function () {
  var DESKTOP_BP = 750;
  var PX_PER_LINE = 44;
  var BASE_REM = 14; // correspond au 14rem du template

  function adjust() {
    var bg = document.querySelector('.product-collection-bg');
    var h1 = document.querySelector('.product-information h1, .view-product-title h1');
    if (!bg || !h1) return;

    if (window.innerWidth < DESKTOP_BP) {
      bg.style.removeProperty('height');
      return;
    }

    var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    var lineHeight = parseFloat(getComputedStyle(h1).lineHeight) || parseFloat(getComputedStyle(h1).fontSize) * 1.2;
    var lines = Math.round(h1.offsetHeight / lineHeight);
    var extra = Math.max(0, lines - 1) * PX_PER_LINE;
    var basePx = BASE_REM * rootFontSize;

    bg.style.height = (basePx + extra) + 'px';
  }

  function init() {
    adjust();
    window.addEventListener('resize', adjust, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Pure Serre — Hero external video override
 * Replaces the hero section video with an external CDN source.
 */
(function () {
  const HERO_VIDEO_SRC = 'https://media.pureserre.com/lush-greenhouse-interior-filled-with-vibrant-potted-plants-and-seedlings-free-video.mp4';

  function replaceHeroVideo() {
    const hero = document.querySelector('.hero, [data-testid="hero"], section[class*="hero"]');
    if (!hero) return;

    // Force-replace ALL video sources in hero unconditionally
    hero.querySelectorAll('video').forEach(function (video) {
      video.pause();
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach(function (s) { s.remove(); });

      const source = document.createElement('source');
      source.src = HERO_VIDEO_SRC;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
      video.play().catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceHeroVideo);
  } else {
    replaceHeroVideo();
  }
})();

/* =====================================================
   Badge produit → before du titre (dynamique)
   ===================================================== */
(function () {
  function moveBadgesToTitles(root) {
    (root || document).querySelectorAll('product-card').forEach(function (card) {
      var badgeEl = card.querySelector('.product-badges__badge');
      if (!badgeEl) return;
      var text = badgeEl.textContent.trim();
      if (!text) return;
      var textBlock = card.querySelector('.product-card__content .contents > .text-block');
      if (!textBlock || textBlock.dataset.badge) return; // already done
      textBlock.dataset.badge = text;
      var badgesWrapper = badgeEl.closest('.product-badges');
      if (badgesWrapper) badgesWrapper.classList.add('product-badges--moved');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { moveBadgesToTitles(); });
  } else {
    moveBadgesToTitles();
  }

  // Cover async-rendered cards (recommendations, quick-add, etc.)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) moveBadgesToTitles(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/* =====================================================
   Track123 — texte bouton + ligne de rassurance
   ===================================================== */
(function () {
  function upgradeTrackingPage() {
    // Rename submit button
    const btn = document.getElementById('track123_submit_button');
    if (btn && btn.textContent.trim().length < 10) {
      btn.textContent = 'Suivre ma commande';
    }

    // Inject reassurance line under the title (once)
    const title = document.getElementById('track123_track_title');
    if (title && !document.getElementById('track123_reassurance')) {
      const line = document.createElement('p');
      line.id = 'track123_reassurance';
      line.textContent = 'Suivez votre livraison en temps réel — accès rapide à votre commande.';
      line.style.cssText = 'font-size:0.85rem;color:var(--color-primary-button-background,#4a5545);margin:0 0 1.5rem;line-height:1.6;';
      title.insertAdjacentElement('afterend', line);
    }
  }

  // Run on load + watch for Track123 async render
  const observer = new MutationObserver(function () {
    if (document.getElementById('track123_track_title')) {
      upgradeTrackingPage();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeTrackingPage);
  } else {
    upgradeTrackingPage();
  }
})();

/* =====================================================
   Prix instantané — mise à jour préchargée + bouton
   ===================================================== */
(function () {
  /* Formateur monétaire inline (reproduit le filtre Liquid | money) */
  function psFormatMoney(cents, format, currency) {
    var zeroDec = ['JPY','KRW','VND','BIF','CLP','GNF','ISK','MGA','PYG','RWF','UGX','XAF','XOF','XPF','HUF','TWD'];
    var prec = zeroDec.indexOf((currency || '').toUpperCase()) !== -1 ? 0 : 2;
    var div = Math.pow(10, prec);
    return (format || '{{amount}}').replace(/{{\s*(\w+)\s*}}/g, function (_, ph) {
      if (ph === 'currency') return currency || '';
      var t = ',', d = '.', p = prec;
      if (ph === 'amount_no_decimals') { p = 0; }
      else if (ph === 'amount_with_comma_separator') { t = '.'; d = ','; }
      else if (ph === 'amount_no_decimals_with_comma_separator') { t = '.'; p = 0; }
      else if (ph === 'amount_no_decimals_with_space_separator') { t = ' '; p = 0; }
      else if (ph === 'amount_with_space_separator') { t = ' '; d = ','; }
      else if (ph === 'amount_with_period_and_space_separator') { t = ' '; d = '.'; }
      else if (ph === 'amount_with_apostrophe_separator') { t = "'"; d = '.'; }
      var n = (cents / div).toFixed(p);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\d(?=(\d{3})+(?!\d))/g, '$&' + t);
      return p <= 0 ? parts[0] : parts[0] + d + (parts[1] || '').padEnd(p, '0');
    });
  }

  /* Cache de prix : { variantId: { price, cmp, avail } } */
  var priceCache = null;

  function buildPriceCache() {
    if (priceCache) return priceCache;
    priceCache = {};
    var script = document.querySelector('variant-picker script[data-ps-variant-prices]');
    if (!script) return priceCache;
    try {
      JSON.parse(script.textContent).forEach(function (v) {
        priceCache[v.id] = { price: v.price, cmp: v.cmp, avail: v.avail };
      });
    } catch (e) {}
    return priceCache;
  }

  function getPickerMeta() {
    var picker = document.querySelector('variant-picker[data-money-format]');
    if (!picker) return null;
    // Scope = la section Shopify qui contient le picker (évite les sections recommendations)
    var scope = picker.closest('.shopify-section') || picker.closest('section') || document;
    return { fmt: picker.dataset.moneyFormat, cur: picker.dataset.currency || 'EUR', scope: scope };
  }

  /* Applique le prix sur un priceContainer (div[ref="priceContainer"]) */
  function applyPriceToContainer(container, v, meta) {
    var regularDiv = container.querySelector('.price__regular');
    var saleDiv = container.querySelector('.price__sale');
    var discountBadge = container.querySelector('[data-price-discount-badge]');
    var discountValue = container.querySelector('[data-price-discount-value]');
    var isSerrePrice = container.hasAttribute('data-is-serre-price');
    var fmt = psFormatMoney(v.price, meta.fmt, meta.cur);
    var compareAt = v.cmp && v.cmp > v.price ? v.cmp : 0;

    if (isSerrePrice && compareAt <= v.price) {
      compareAt = 0;
    }

    var isOnSale = compareAt && compareAt > v.price;

    if (discountBadge) {
      if (isOnSale) {
        var pct = Math.round(((compareAt - v.price) * 100) / compareAt);
        if (discountValue) discountValue.textContent = String(pct);
        discountBadge.classList.remove('price-discount-badge--hidden');
      } else {
        discountBadge.classList.add('price-discount-badge--hidden');
      }
    }

    if (isOnSale) {
      var cmpFmt = psFormatMoney(compareAt, meta.fmt, meta.cur);
      if (regularDiv) regularDiv.classList.add('price__hidden');
      if (saleDiv) {
        saleDiv.classList.remove('price__hidden');
        var saleEl = saleDiv.querySelector('.price-item--sale, .price');
        var cmpEl = saleDiv.querySelector('.price-item--regular, .compare-at-price');
        if (saleEl) saleEl.textContent = fmt;
        if (cmpEl) cmpEl.textContent = cmpFmt;
      }
    } else {
      if (regularDiv) {
        regularDiv.classList.remove('price__hidden');
        var priceEl = regularDiv.querySelector('.price');
        if (priceEl) priceEl.textContent = fmt;
      }
      if (saleDiv) saleDiv.classList.add('price__hidden');
    }
  }

  /* Flash animation sur le prix */
  function flashPriceEl(el) {
    el.classList.remove('ps-price-updated');
    void el.offsetWidth; // reflow pour re-déclencher l'animation
    el.classList.add('ps-price-updated');
    // La classe est retirée au prochain appel (remove+reflow), inutile d'écouter animationend
  }

  /* Mise à jour immédiate de TOUS les prix (main product-price + sticky bar) */
  function applyPriceInstant(variantId) {
    var cache = buildPriceCache();
    var meta = getPickerMeta();
    if (!meta) return false;
    var v = cache[parseInt(variantId, 10)];
    if (!v) return false;

    // 1. product-price dans la même section que le picker (pas les cartes recommendations)
    meta.scope.querySelectorAll('product-price [ref="priceContainer"]').forEach(function (container) {
      applyPriceToContainer(container, v, meta);
      var priceEl = container.closest('product-price');
      if (priceEl) flashPriceEl(priceEl);
    });

    // 2. Prix dans la sticky bar — multiplié par la quantité courante
    var stickyQty = window.__psQty || 1;
    document.querySelectorAll('.sticky-add-to-cart__price').forEach(function (stickyPrice) {
      var vForSticky = stickyQty > 1
        ? { price: v.price * stickyQty, cmp: v.cmp ? v.cmp * stickyQty : 0, avail: v.avail }
        : v;
      var container = stickyPrice.querySelector('[ref="priceContainer"]') || stickyPrice;
      applyPriceToContainer(container, vForSticky, meta);
      flashPriceEl(stickyPrice);
    });

    // 3. Partager le prix unitaire avec le configurateur (autre IIFE) via window
    window.__psUnitPrice = v.price;
    window.__psFmt = meta.fmt;
    window.__psCur = meta.cur;

    return v.avail;
  }

  function setButtonLoading(loading) {
    document.querySelectorAll('add-to-cart-component').forEach(function (el) {
      el.classList.toggle('btn--loading', loading);
    });
  }

  // Sur changement d'option : met à jour les prix instantanément
  // Stock toujours disponible — pas de logique de dispo
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.variant-picker__form')) return;
    var variantId = e.target.dataset && e.target.dataset.variantId;
    if (!variantId) return;
    applyPriceInstant(variantId);
    setButtonLoading(true);

    // Mise à jour instantanée du texte variante dans la sticky bar
    try {
      var picker = document.querySelector('variant-picker');
      if (picker) {
        var selectedOptions = Array.from(picker.querySelectorAll('input:checked'))
          .map(function (input) { return input.value; })
          .filter(function (v) { return v !== ''; })
          .join(' / ');
        if (selectedOptions) {
          document.querySelectorAll('sticky-add-to-cart .sticky-add-to-cart__variant').forEach(function (el) {
            el.textContent = selectedOptions;
          });
        }
      }
    } catch (e2) {}
  });

  /* Patch prototype : rend impossible de mettre disabled=true sur les boutons ATC uniquement */
  (function () {
    function isAtcButton(el) {
      return el.matches('[ref="addToCartButton"]') ||
        (el.type === 'submit' && !!el.closest('add-to-cart-component')) ||
        el.classList.contains('sticky-add-to-cart__button') ||
        (el.matches('[ref="plusButton"]') && !!el.closest('add-to-cart-component'));
    }

    // 1. Patch du setter de propriété (btn.disabled = true)
    var desc = Object.getOwnPropertyDescriptor(HTMLButtonElement.prototype, 'disabled');
    if (desc) {
      Object.defineProperty(HTMLButtonElement.prototype, 'disabled', {
        get: desc.get,
        set: function (val) {
          if (val && isAtcButton(this)) return;
          desc.set.call(this, val);
        },
        configurable: true
      });
    }

    // 2. Patch de setAttribute — bloque disabled sur boutons ATC, et data-stuck='false' sur sticky bar
    var origSetAttr = Element.prototype.setAttribute;
    Element.prototype.setAttribute = function (name, value) {
      if (name === 'disabled' && this instanceof HTMLButtonElement && isAtcButton(this)) return;
      if (name === 'data-stuck' && value === 'false' && this.closest('sticky-add-to-cart')) return;
      origSetAttr.call(this, name, value);
    };

    // 3. Forcer data-stuck='true' dès que le sticky bar est dans le DOM
    function forceStickyBarStuck() {
      document.querySelectorAll('sticky-add-to-cart [ref="stickyBar"]').forEach(function (bar) {
        origSetAttr.call(bar, 'data-stuck', 'true');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', forceStickyBarStuck);
    } else {
      forceStickyBarStuck();
    }
    // Au cas où le sticky bar est injecté dynamiquement
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var bar = node.matches && node.matches('[ref="stickyBar"]') ? node : (node.querySelector && node.querySelector('[ref="stickyBar"]'));
          if (bar) origSetAttr.call(bar, 'data-stuck', 'true');
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  function ensureAtcIcon(btn) {
    return;
  }

  /* Force le bouton ATC toujours actif (stock toujours disponible) */
  function forceButtonEnabled() {
    var tr = (typeof Theme !== 'undefined' && Theme.translations) || {};
    var addText = tr.add_to_cart || 'Ajouter au panier';

    document.querySelectorAll('add-to-cart-component button[ref="addToCartButton"], add-to-cart-component button[type="submit"]').forEach(function (btn) {
      btn.disabled = false;
      ensureAtcIcon(btn);
      // Corriger le texte si le thème a mis "Non disponible(s)" ou "Sold out"
      // Ne pas écraser les boutons bundle-card qui ont leur propre texte
      var isBundleBtn = btn.closest('.bundle-card__cta') !== null;
      var textEl = btn.querySelector('.add-to-cart-text__content span:first-child');
      if (textEl && !isBundleBtn && textEl.textContent.trim() !== addText) {
        textEl.textContent = addText;
      }
    });
    document.querySelectorAll('sticky-add-to-cart').forEach(function (el) {
      el.dataset.variantAvailable = 'true';
    });
    document.querySelectorAll('.sticky-add-to-cart__button').forEach(function (btn) {
      btn.disabled = false;
      ensureAtcIcon(btn);
      // Corriger aussi le texte dans la sticky bar (rendu Liquid avec "Épuisé")
      var textEl = btn.querySelector('.add-to-cart-text__content span:first-child');
      if (textEl && textEl.textContent.trim() !== addText) {
        textEl.textContent = addText;
      }
    });
    // Forcer la sticky bar toujours visible (data-stuck='true')
    document.querySelectorAll('sticky-add-to-cart [ref="stickyBar"]').forEach(function (bar) {
      if (bar.getAttribute('data-stuck') !== 'true') {
        bar.setAttribute('data-stuck', 'true');
      }
    });
  }

  /* MutationObserver — re-force enabled dès que le thème remet disabled */
  function watchButtons() {
    var config = { attributes: true, attributeFilter: ['disabled'] };

    function observeBtn(btn) {
      new MutationObserver(function () {
        if (btn.disabled) btn.disabled = false;
      }).observe(btn, config);
    }

    function observeStickyAtc(el) {
      new MutationObserver(function () {
        if (el.dataset.variantAvailable !== 'true') el.dataset.variantAvailable = 'true';
      }).observe(el, { attributes: true, attributeFilter: ['data-variant-available'] });
    }

    // Observer data-stuck — forcer inline styles directement (CSS cascade ne suffit pas)
    function lockBarVisible(bar) {
      if (bar.classList.contains('ps-sticky--dismissed')) return;
      bar.style.setProperty('position', 'fixed');
      bar.style.setProperty('bottom', '16px');
      bar.style.setProperty('left', '12px');
      bar.style.setProperty('right', '12px');
      bar.style.removeProperty('max-width');
      bar.style.setProperty('display', 'flex');
      bar.style.setProperty('opacity', '1');
      bar.style.setProperty('transform', 'none');
      bar.style.setProperty('transition', 'none');
      bar.style.setProperty('animation', 'none');
      bar.style.setProperty('pointer-events', 'auto');
      if (bar.getAttribute('data-stuck') !== 'true') {
        bar.setAttribute('data-stuck', 'true');
      }
    }

    // Téléporter sticky-add-to-cart dans document.body
    // pour échapper aux ancêtres avec transform qui cassent position:fixed
    function teleportStickyBar(el) {
      if (el.dataset.teleported === 'true') return;
      el.dataset.teleported = 'true';
      document.body.appendChild(el);
    }

    function observeStickyBar(bar) {
      lockBarVisible(bar);
      new MutationObserver(function () {
        lockBarVisible(bar);
      }).observe(bar, { attributes: true, attributeFilter: ['data-stuck', 'style'] });
    }

    // Observer les boutons déjà présents
    document.querySelectorAll('add-to-cart-component button[ref="addToCartButton"], add-to-cart-component button[type="submit"], .sticky-add-to-cart__button').forEach(observeBtn);
    document.querySelectorAll('sticky-add-to-cart').forEach(function (el) {
      teleportStickyBar(el);
      observeStickyAtc(el);
    });
    document.querySelectorAll('sticky-add-to-cart [ref="stickyBar"]').forEach(observeStickyBar);

    // Observer les boutons ajoutés dynamiquement (section renderer remplace tout l'HTML)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          // Forcer immédiatement + observer pour les futurs changements d'attribut
          node.querySelectorAll && node.querySelectorAll('add-to-cart-component button, .sticky-add-to-cart__button').forEach(function (btn) {
            btn.disabled = false;
            observeBtn(btn);
          });
          node.querySelectorAll && node.querySelectorAll('sticky-add-to-cart').forEach(function (el) {
            el.dataset.variantAvailable = 'true';
            teleportStickyBar(el);
            observeStickyAtc(el);
          });
          node.querySelectorAll && node.querySelectorAll('sticky-add-to-cart [ref="stickyBar"]').forEach(function (bar) {
            bar.setAttribute('data-stuck', 'true');
            observeStickyBar(bar);
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Au premier chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { forceButtonEnabled(); watchButtons(); });
  } else {
    forceButtonEnabled();
    watchButtons();
  }

  // Quand la réponse serveur arrive : invalide le cache, retire l'animation flash, restaure le bouton
  document.addEventListener('variant:update', function (event) {
    // Retire la classe d'animation avant que le thème touche le DOM — évite la double animation
    document.querySelectorAll('.ps-price-updated').forEach(function (el) {
      el.classList.remove('ps-price-updated');
    });
    priceCache = null; // le DOM a changé, on relit au prochain changement

    // Mise à jour du texte variante dans la sticky bar (perdu après téléportation vers body)
    try {
      var newHtml = event && event.detail && event.detail.data && event.detail.data.html;
      if (newHtml) {
        var newVariantEl = newHtml.querySelector('.sticky-add-to-cart__variant');
        if (newVariantEl) {
          document.querySelectorAll('sticky-add-to-cart .sticky-add-to-cart__variant').forEach(function (el) {
            el.textContent = newVariantEl.textContent;
          });
        }
      }
    } catch (e) {}

    setButtonLoading(false);
    // Le thème peut marquer le variant comme indisponible APRÈS cet event.
    // On force toujours disponible (stock illimité) en passant après lui via setTimeout.
    // Timeouts en cascade : couvre tous les timings possibles du thème
    setTimeout(forceButtonEnabled, 0);
    setTimeout(forceButtonEnabled, 100);
    setTimeout(forceButtonEnabled, 300);

    // Mise à jour badge Klarna
    try {
      var variantData = event && event.detail && event.detail.resource;
      if (variantData && variantData.price !== undefined) {
        updateKlarnaBadge(variantData.price);
      }
    } catch (e) {}
  });
})();

/* =====================================================
   Badge Klarna — 3× sans frais si prix > 1000 €
   ===================================================== */
(function () {
  var THRESHOLD = 100000; // 1000 € en centimes Shopify

  function formatKlarnaAmount(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{[^}]+\}\}/, amount);
  }

  function updateKlarnaBadge(priceCents) {
    document.querySelectorAll('[data-ps-klarna]').forEach(function (badge) {
      if (priceCents >= THRESHOLD) {
        var installment = Math.round(priceCents / 3);
        var amountEl = badge.querySelector('[data-ps-klarna-amount]');
        if (amountEl) amountEl.textContent = formatKlarnaAmount(installment);
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    });
  }

  window.updateKlarnaBadge = updateKlarnaBadge;
})();


/* =====================================================
   Bouton Agent IA — ouvre le chat UaeLead
   ===================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var t = /** @type {Element} */ (e.target);
    if (!t || !t.closest) return;
    if (!t.closest('[data-ps-ai-chat]')) return;
    e.preventDefault();
    var w = /** @type {any} */ (window);
    if (w.UAELead && typeof w.UAELead.open === 'function') {
      w.UAELead.open();
    }
  });
})();

/* =====================================================
   UaeLead — cacher la bulle flottante via JS
   Le display:none sur #ual-wrap bloque le panel de chat,
   on cible uniquement le bouton trigger via MutationObserver
   ===================================================== */
(function () {
  function isPanel(el) {
    if (el.querySelector('iframe')) return true;
    if (el.getAttribute('role') === 'dialog') return true;
    if (el.querySelectorAll('*').length > 15) return true;
    return false;
  }

  function hideBubble() {
    if (window.innerWidth >= 750) return; // bulle visible sur desktop
    var wrap = document.getElementById('ual-wrap');
    if (!wrap) return;
    var w = /** @type {any} */ (window);
    if (w.UAELead && typeof w.UAELead.isOpen === 'function' && w.UAELead.isOpen()) return;
    for (var i = 0; i < wrap.children.length; i++) {
      var child = /** @type {HTMLElement} */ (wrap.children[i]);
      if (!isPanel(child)) {
        child.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function showBubble() {
    var wrap = document.getElementById('ual-wrap');
    if (!wrap) return;
    for (var i = 0; i < wrap.children.length; i++) {
      var child = /** @type {HTMLElement} */ (wrap.children[i]);
      if (!isPanel(child)) {
        child.style.removeProperty('display');
      }
    }
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 750) { showBubble(); } else { hideBubble(); }
  });

  var wrapObs = new MutationObserver(function () { hideBubble(); });

  function watchWrap() {
    var wrap = document.getElementById('ual-wrap');
    if (!wrap) return;
    hideBubble();
    wrapObs.observe(wrap, { childList: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  var bodyObs = new MutationObserver(function () {
    if (document.getElementById('ual-wrap')) {
      bodyObs.disconnect();
      setTimeout(watchWrap, 200);
    }
  });
  bodyObs.observe(document.body, { childList: true, subtree: true });

  watchWrap();
  setTimeout(watchWrap, 1000);
  setTimeout(watchWrap, 3000);
})();

/* =====================================================
   Sélection visuelle instantanée — pointerdown
   Déclenché AVANT click/change, zéro latence perçue
   ===================================================== */
(function () {
  var _startX = 0, _startY = 0, _didScroll = false;
  /** @type {Element|null} */ var _pendingLabel = null;
  /** @type {Element|null} */ var _pendingFieldset = null;
  /** @type {Element|null} */ var _prevLabel = null;

  function initInstantSelect() {
    document.addEventListener('pointerdown', function (e) {
      _didScroll = false;
      _startX = e.clientX;
      _startY = e.clientY;
      _pendingLabel = null;
      _prevLabel = null;

      var t = /** @type {Element} */ (e.target);
      if (!t || !t.closest) return;
      var label = t.closest('.variant-option__button-label');
      if (!label) return;
      if (label.classList.contains('variant-option__button-label--has-swatch')) return;
      var fieldset = label.closest('.variant-option--buttons');
      if (!fieldset) return;

      _pendingLabel = label;
      _pendingFieldset = fieldset;
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      _prevLabel = checked ? checked.closest('.variant-option__button-label') : null;

      fieldset.querySelectorAll('.variant-option__button-label').forEach(function (l) {
        l.classList.remove('ps-option-selected');
      });
      label.classList.add('ps-option-selected');
    }, { passive: true });

    document.addEventListener('pointermove', function (e) {
      if (_didScroll || !_pendingLabel) return;
      var dx = e.clientX - _startX;
      var dy = e.clientY - _startY;
      if (Math.sqrt(dx * dx + dy * dy) > 8) {
        _didScroll = true;
        if (_pendingFieldset) {
          _pendingFieldset.querySelectorAll('.variant-option__button-label').forEach(function (/** @type {Element} */ l) {
            l.classList.remove('ps-option-selected');
          });
          if (_prevLabel) _prevLabel.classList.add('ps-option-selected');
        }
      }
    }, { passive: true });

    // Capture phase — annule le click si c'était un scroll
    document.addEventListener('click', function (e) {
      if (!_didScroll) return;
      var t = /** @type {Element} */ (e.target);
      if (!t || !t.closest) return;
      if (!t.closest('.variant-option__button-label')) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }
  initInstantSelect();
})();

/* =====================================================
   Description accordion — suppression des deux-points
   après les titres <strong> dans les <li>
   ===================================================== */
(function () {
  function cleanDescriptionColons() {
    document.querySelectorAll(
      '.product-details .accordion .details-content .rte li'
    ).forEach(function (li) {
      // Majuscule forcée sur la première lettre des balises <strong>
      li.querySelectorAll('strong').forEach(function (strong) {
        var t = strong.textContent;
        if (t.length > 0) strong.textContent = t.charAt(0).toUpperCase() + t.slice(1);
      });
      // Retire " : ", ": ", ", " en début de n'importe quel nœud texte dans le <li>
      var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        node.textContent = node.textContent.replace(/^\s*[,:]\s*/, '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanDescriptionColons);
  } else {
    cleanDescriptionColons();
  }
})();

/* =====================================================
   Metafields custom → cartes collection
   Injecte --card-subtitle et --card-reassurance comme
   CSS custom properties, lues par les pseudo-éléments.
   Fonctionne aussi avec le défilement infini.
   ===================================================== */
(function () {
  function injectCardMeta(root) {
    (root || document).querySelectorAll('.product-grid__item[data-subtitle], .product-grid__item[data-reassurance]').forEach(function (li) {
      var subtitle = li.dataset.subtitle;
      var reassurance = li.dataset.reassurance;
      if (subtitle) {
        var tb = li.querySelector('.text-block');
        if (tb) tb.style.setProperty('--card-subtitle', JSON.stringify(subtitle));
      }
      if (reassurance) {
        var pp = li.querySelector('product-price');
        if (pp) pp.style.setProperty('--card-reassurance', JSON.stringify(reassurance));
      }
      // Fade in the pseudo-element text now that real values are set
      li.style.setProperty('--card-ready', '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { injectCardMeta(); });
  } else {
    injectCardMeta();
  }

  // Infinite scroll — observe new cards added to the grid
  var grid = document.querySelector('.product-grid');
  if (grid) {
    new MutationObserver(function () { injectCardMeta(); }).observe(grid, { childList: true, subtree: false });
  }
})();

/* =====================================================
   Product configurator — badge "Recommandé" + résumé
   dynamique + parallax hero
   Métadonnées utilisées (namespace "custom") :
     recommended_options : JSON  {"Option": "Valeur", ...}
       ex: {"Épaisseur": "6 mm", "Dimension": "3×8"}
     summary_title       : texte libre (défaut: "Votre serre")
   ===================================================== */
(function () {
  /* ---- Formateur monétaire local (psFormatMoney est dans un autre IIFE) ---- */
  function fmtMoney(cents, format, currency) {
    var zeroDec = ['JPY','KRW','VND','BIF','CLP','GNF','ISK','MGA','PYG','RWF','UGX','XAF','XOF','XPF','HUF','TWD'];
    var prec = zeroDec.indexOf((currency || '').toUpperCase()) !== -1 ? 0 : 2;
    var div = Math.pow(10, prec);
    return (format || '{{amount}}').replace(/{{\s*(\w+)\s*}}/g, function (_, ph) {
      if (ph === 'currency') return currency || '';
      var t = ',', d = '.', p = prec;
      if (ph === 'amount_no_decimals') { p = 0; }
      else if (ph === 'amount_with_comma_separator') { t = '.'; d = ','; }
      else if (ph === 'amount_no_decimals_with_comma_separator') { t = '.'; p = 0; }
      else if (ph === 'amount_no_decimals_with_space_separator') { t = ' '; p = 0; }
      else if (ph === 'amount_with_space_separator') { t = ' '; d = ','; }
      else if (ph === 'amount_with_period_and_space_separator') { t = ' '; d = '.'; }
      else if (ph === 'amount_with_apostrophe_separator') { t = "'"; d = '.'; }
      var n = (cents / div).toFixed(p);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\d(?=(\d{3})+(?!\d))/g, '$&' + t);
      return p <= 0 ? parts[0] : parts[0] + d + (parts[1] || '').padEnd(p, '0');
    });
  }

  /* ---- helpers ---- */
  function getMeta(key) {
    var el = document.getElementById('ps-product-metafields');
    return el ? (el.dataset[key] || '') : '';
  }

  /* ---- Badge Recommandé ---- */
  function injectRecommendedBadges() {
    var raw = getMeta('recommendedOptions');
    if (!raw) return;
    var recommended;
    try { recommended = JSON.parse(raw); } catch (e) { return; }

    document.querySelectorAll('.variant-option--buttons').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;
      var optionName = legend.textContent.trim();
      var recValue = recommended[optionName];
      if (!recValue) return;

      fieldset.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        var textEl = label.querySelector('.variant-option__button-label__text');
        if (!textEl) return;
        if (textEl.textContent.trim() === recValue) {
          label.classList.add('variant-option__button-label--recommended');
          label.dataset.recommendedLabel = 'Recommand\u00e9';
        }
      });
    });
  }

  /* ---- Descriptions & hints par option ---- */
  function injectOptionDescs() {
    // 1. Surcharges JSON depuis metafield data-option-descriptions
    var customRaw = getMeta('optionDescriptions');
    var custom = {};
    if (customRaw) { try { custom = JSON.parse(customRaw); } catch (e) {} }

    // 2. Carte par défaut (correspondance insensible à la casse sur option.name)
    var defaults = {
      "niveau d'isolation": {
        hint: "Choisissez le niveau d'isolation adapté à votre usage",
        values: {
          '4 mm': 'Idéal pour la serre de jardin estivale',
          '6 mm': 'Isolation renforcée — confort toutes saisons'
        }
      },
      'taille de la serre': {
        hint: 'Sélectionnez la surface cultivable adaptée à votre jardin',
        recommended: { key: '3 x 6 m', label: '⭐ Notre recommandation', subtext: 'Idéal pour prolonger les saisons de culture' },
        values: {
          '3 x 4 m': 'Petit espace de culture',
          '3 x 6 m': 'Parfait pour jardin polyvalent',
          '3 x 8 m': 'Idéal pour jardinier passionné',
          '3 x 10 m': 'Production intensive'
        }
      }
    };

    var recInjected = false;
    document.querySelectorAll('.variant-option--buttons').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;
      var rawName = legend.childNodes[0] ? legend.childNodes[0].textContent.trim() : legend.textContent.trim();
      var key = rawName.toLowerCase().replace(/\u2019/g, "'").replace(/\u2018/g, "'");
      var meta = custom[rawName] || custom[key] || defaults[key] || null;
      if (!meta) return;

      // Injecter le hint dans le fieldset après la légende (une seule fois)
      if (meta.hint && !fieldset.querySelector('.ps-option-hint')) {
        var hint = document.createElement('div');
        hint.className = 'ps-option-hint';
        hint.textContent = meta.hint;
        legend.insertAdjacentElement('afterend', hint);
      }

      // Injecter la description dans chaque label
      fieldset.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        if (label.querySelector('.ps-option-desc')) return;
        var textEl = label.querySelector('.variant-option__button-label__text');
        if (!textEl) return;
        var valueRaw = textEl.textContent.trim();
        var valueKey = valueRaw.toLowerCase();
        var desc = (meta.values || {})[valueRaw] || (meta.values || {})[valueKey] || '';
        if (desc) {
          var descEl = document.createElement('span');
          descEl.className = 'ps-option-desc';
          descEl.textContent = desc;
          textEl.insertAdjacentElement('afterend', descEl);
        }
        // Badge recommandé — un seul sur toute la page, inline à côté du titre
        if (!recInjected && meta.recommended && !label.querySelector('.variant-option__recommended-badge')) {
          var recKey = (meta.recommended.key || '').toLowerCase();
          if (valueKey === recKey) {
            var wrap = document.createElement('span');
            wrap.className = 'variant-option__recommended-wrap';
            var badge = document.createElement('span');
            badge.className = 'variant-option__recommended-badge';
            badge.textContent = meta.recommended.label || '⭐ Notre recommandation';
            wrap.appendChild(badge);
            if (meta.recommended.subtext) {
              var sub = document.createElement('span');
              sub.className = 'variant-option__recommended-subtext';
              sub.textContent = meta.recommended.subtext;
              wrap.appendChild(sub);
            }
            // Envelopper titre + badge dans une ligne flex
            var titleRow = document.createElement('span');
            titleRow.className = 'variant-option__title-row';
            textEl.parentNode.insertBefore(titleRow, textEl);
            titleRow.appendChild(textEl);
            titleRow.appendChild(wrap);
            recInjected = true;
          }
        }
      });
    });
  }

  /* ---- Prix dynamiques dans les cartes de variantes ---- */
  function updateCardPrices() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var productId = picker.getAttribute('data-product-id');
    var dataScript = document.getElementById('ps-variant-data-' + productId);
    if (!dataScript) return;
    /** @type {Array<{id:number,opts:string[],price:number,cmp:number}>} */
    var variants;
    try { variants = JSON.parse(dataScript.textContent || '[]'); } catch (e) { return; }

    var fmt = (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}} €';

    /** @type {Object.<string, string>} */
    var selected = {};
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
      var input = /** @type {HTMLInputElement} */ (el);
      selected[input.getAttribute('data-fieldset-index') || '0'] = input.value;
    });

    picker.querySelectorAll('.variant-option--buttons').forEach(function (fieldset) {
      var fi = fieldset.getAttribute('data-fieldset-index') || '0';
      fieldset.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        var inputEl = /** @type {HTMLInputElement|null} */ (label.querySelector('input[type="radio"]'));
        if (!inputEl) return;

        var targetOpts = Object.assign({}, selected);
        targetOpts[fi] = inputEl.value;

        var matched = variants.find(function (v) {
          return v.opts.every(function (opt, i) {
            return targetOpts[String(i)] === undefined || opt === targetOpts[String(i)];
          });
        });

        if (!matched) return;

        var existing = label.querySelector('.ps-option-price');
        var priceEl = existing || document.createElement('span');
        priceEl.className = 'ps-option-price';

        var priceStr = fmt.replace(/\{\{(\s*)(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)(\s*)\}\}/g, function (_, _a, type) {
          var cents = matched.price;
          if (type === 'amount' || type === 'amount_with_comma_separator') return (cents / 100).toFixed(2).replace('.', ',');
          return Math.round(cents / 100).toString();
        });

        var html = '';
        if (matched.cmp && matched.cmp > matched.price) {
          var cmpStr = fmt.replace(/\{\{(\s*)(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)(\s*)\}\}/g, function (_, _a, type) {
            var cents = matched.cmp;
            if (type === 'amount' || type === 'amount_with_comma_separator') return (cents / 100).toFixed(2).replace('.', ',');
            return Math.round(cents / 100).toString();
          });
          html = '<span class="ps-option-price__compare">' + cmpStr + '</span>' + priceStr;
        } else {
          html = priceStr;
        }

        priceEl.innerHTML = html;
        if (!existing) {
          var descEl = label.querySelector('.ps-option-desc');
          if (descEl) descEl.insertAdjacentElement('afterend', priceEl);
          else label.appendChild(priceEl);
        }
      });
    });
  }

  /* ---- Résumé dynamique ---- */
  var summaryEl = null;
  var psSummaryUnitPrice = 0; // cents
  var psSummaryFmt = '';
  var psSummaryCur = 'EUR';
  var psSummaryQty = 1;

  function initSummaryPriceData() {
    if (!psSummaryFmt) {
      psSummaryFmt = (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}}\u00a0\u20ac';
      psSummaryCur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    }
    // Priorité 1 : prix partagé par applyPriceInstant (toujours à jour après un changement de variante)
    if (window.__psUnitPrice) {
      psSummaryUnitPrice = window.__psUnitPrice;
      if (window.__psFmt) psSummaryFmt = window.__psFmt;
      if (window.__psCur) psSummaryCur = window.__psCur;
      return;
    }
    // Priorité 2 : script JSON data-ps-variant-prices
    try {
      var script = document.querySelector('variant-picker script[data-ps-variant-prices]');
      if (script) {
        var variants = JSON.parse(script.textContent);
        var selectedInput = document.querySelector('variant-picker input[type="radio"]:checked');
        var selectedId = selectedInput && selectedInput.dataset && parseInt(selectedInput.dataset.variantId, 10);
        var found = selectedId && variants.find(function(v) { return v.id === selectedId; });
        var vdata = found || variants[0];
        if (vdata && vdata.price) { psSummaryUnitPrice = vdata.price; return; }
      }
    } catch (e) {}
    // Priorité 3 : ShopifyAnalytics
    try {
      var analyticsVariants = window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants;
      if (analyticsVariants && analyticsVariants.length) { psSummaryUnitPrice = analyticsVariants[0].price; return; }
    } catch (e) {}
    // Priorité 4 : DOM product-price
    try {
      var sEl = document.querySelector('product-price .price__sale .price-item--sale');
      var rEl = document.querySelector('product-price .price__regular .price-item, product-price .price__regular .price');
      var el = sEl || rEl;
      if (el) {
        var priceText = el.textContent.trim().replace(/[^0-9,\.]/g, '').replace(',', '.');
        var parsed = parseFloat(priceText);
        if (parsed > 0) psSummaryUnitPrice = Math.round(parsed * 100);
      }
    } catch (e) {}
  }

  function updateSummaryPriceDisplay() {
    var priceEl = document.getElementById('ps-summary-price');
    var labelEl = document.getElementById('ps-summary-price-label');
    if (!priceEl) return;
    if (!psSummaryUnitPrice || !psSummaryFmt) return;
    var total = psSummaryUnitPrice * psSummaryQty;
    var fmtTotal = fmtMoney(total, psSummaryFmt, psSummaryCur);
    if (priceEl.textContent !== fmtTotal) {
      priceEl.classList.remove('ps-price-animating');
      void priceEl.offsetWidth;
      priceEl.textContent = fmtTotal;
      priceEl.classList.add('ps-price-animating');
      priceEl.addEventListener('animationend', function () {
        priceEl.classList.remove('ps-price-animating');
      }, { once: true });
    }
    if (labelEl) labelEl.textContent = psSummaryQty > 1 ? 'Prix total' : 'Prix';
  }

  function _pcEsc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function _pcFan(p) {
    var imgs = [p.img1, p.img2, p.img3].filter(Boolean);
    if (!imgs.length) return '';
    var html = '<div class="ps-pc-fan">';
    for (var i = 0; i < imgs.length; i++) {
      html += '<img class="ps-pc-fan__img ps-pc-fan__img--' + (i+1) + '" src="' + _pcEsc(imgs[i]) + '" alt="" loading="lazy">';
    }
    html += '</div>';
    return html;
  }

  function _pcFeatures(str, max) {
    if (!str) return '';
    var items = str.split('|').map(function(s){ return s.trim(); }).filter(Boolean);
    if (max) items = items.slice(0, max);
    if (!items.length) return '';
    var html = '<ul class="ps-pc-features">';
    for (var i = 0; i < items.length; i++) {
      html += '<li>' + _pcEsc(items[i]) + '</li>';
    }
    return html + '</ul>';
  }

  // mod = 'free' | 'featured' | 'premium'
  function _pcCard(p, variant, mod) {
    var cardMod  = ' ps-pc-card--' + mod;
    var badgeMod = '--' + mod;
    var btnMod   = '--' + mod;
    var btnAttr  = mod === 'free'
      ? ('data-pc-email' + (variant ? ' data-pc-variant="' + _pcEsc(String(variant)) + '"' : ''))
      : ('data-pc-atc="' + _pcEsc(String(variant || '')) + '"');
    return '<div class="ps-pc-card' + cardMod + '">' +
      (p.badge ? '<span class="ps-pc-badge ps-pc-badge' + badgeMod + '">' + _pcEsc(p.badge) + '</span>' : '') +
      _pcFan(p) +
      '<p class="ps-pc-name">' + _pcEsc(p.name || '') + '</p>' +
      (p.tagline ? '<p class="ps-pc-tagline">' + _pcEsc(p.tagline) + '</p>' : '') +
      _pcFeatures(p.features) +
      '<button class="ps-pc-btn ps-pc-btn' + btnMod + '" type="button" ' + btnAttr + '>' + _pcEsc(p.cta || 'Choisir') + '</button>' +
    '</div>';
  }

  function _pcImgsFromDom(cardSelector) {
    var card = document.querySelector(cardSelector);
    if (!card) return [];
    // Les URLs sont injectées par Liquid en data-attributes — fiable sans dépendre du chargement des images
    var imgs = [];
    var i1 = card.getAttribute('data-ps-img1');
    var i2 = card.getAttribute('data-ps-img2');
    var i3 = card.getAttribute('data-ps-img3');
    if (i1) imgs.push(i1);
    if (i2) imgs.push(i2);
    if (i3) imgs.push(i3);
    return imgs;
  }

  function buildPackCards() {
    if (document.getElementById('ps-pack-cards')) return;
    var jsonEl = document.getElementById('ps-packs-json');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch(e) { return; }

    // Fallback: lire les images depuis le HTML rendu de la grande section (cfg-inline)
    var domPacks = [
      { key: 'pack1', sel: '.cfg-inline__card--free' },
      { key: 'pack2', sel: '.cfg-inline__card--featured' },
      { key: 'pack3', sel: '.cfg-inline__card--premium' }
    ];
    domPacks.forEach(function(d) {
      var pack = data[d.key] || {};
      // Toujours tenter l'extraction DOM — les images du produit Shopify
      // (cfg-inline) sont plus fiables que le JSON statique
      var imgs = _pcImgsFromDom(d.sel);
      if (imgs[0]) pack.img1 = imgs[0];
      if (imgs[1]) pack.img2 = imgs[1];
      if (imgs[2]) pack.img3 = imgs[2];
      data[d.key] = pack;
    });

    var mainEl = document.querySelector('main[data-template]');
    if (!mainEl || !mainEl.getAttribute('data-template').startsWith('product')) return;

    var anchor = document.querySelector('.ps-configurator-summary')
      || document.querySelector('.buy-buttons-block')
      || document.querySelector('add-to-cart-component');
    if (!anchor) return;

    if (!document.getElementById('ps-pack-cards-css')) {
      var style = document.createElement('style');
      style.id = 'ps-pack-cards-css';
      style.textContent = [
        /* wrapper */
        '.ps-pack-cards{margin-bottom:1.5rem}',
        '.ps-pack-cards__label{font-size:.68rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#6b7669;margin-bottom:.75rem}',
        '.ps-pack-cards__grid{display:grid;grid-template-columns:1fr;gap:.75rem}',
        '.ps-pack-cards__grid>.ps-pc-card{height:100%}',
        '@media(min-width:820px){.ps-pack-cards__grid>.ps-pc-card{height:100%;justify-content:flex-start}}',
        '@media(min-width:820px){.ps-pack-cards__grid{grid-template-columns:repeat(3,1fr)}}',
        '.ps-pack-cards__tabs{display:flex;gap:.4rem;margin-bottom:.75rem}',
        '@media(min-width:820px){.ps-pack-cards__tabs{display:none}}',
        '.ps-pc-tab{flex:1;padding:.45rem .3rem;border-radius:8px;border:1.5px solid #e5e0d8;background:#fff;font-size:.7rem;font-weight:600;cursor:pointer;text-align:center;color:#4a5c4c;transition:all .15s}',
        '.ps-pc-tab.is-active{background:#2d5a3d;color:#fff;border-color:#2d5a3d}',
        '.ps-pc-tab--premium.is-active{background:#c9a84c;border-color:#c9a84c}',
        /* card — display:none par défaut, flex via is-visible ou media query */
        '.ps-pc-card{display:none;border:1.5px solid #e5e0d8;border-radius:16px;padding:1.2rem 1rem;flex-direction:column;gap:.5rem;background:#fff;position:relative;overflow:visible}',
        '.ps-pc-card.is-visible{display:flex}',
        '@media(min-width:820px){.ps-pc-card{display:flex}}',
        '.ps-pc-card--featured{border-color:#2d5a3d;border-width:2px}',
        '.ps-pc-card--premium{border-color:#c9a84c;border-width:2px}',
        /* badge */
        '.ps-pc-badge{font-size:.58rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:.22rem .6rem;border-radius:20px;align-self:flex-start;line-height:1.4;margin-bottom:.2rem}',
        '.ps-pc-badge--free{background:#e8f4ed;color:#1a7a50}',
        '.ps-pc-badge--featured{background:#2d5a3d;color:#fff}',
        '.ps-pc-badge--premium{background:#c9a84c;color:#fff}',
        /* éventail d\'images */
        '.ps-pc-fan{position:relative;width:100%;height:160px;display:flex;align-items:flex-end;justify-content:center;overflow:visible;margin:.5rem 0 .8rem}',
        '.ps-pc-fan__img{position:absolute;width:100px;height:130px;object-fit:cover;border-radius:10px;box-shadow:0 4px 14px rgba(0,0,0,.18)}',
        '.ps-pc-fan__img--1{z-index:3;transform:rotate(0deg) translateX(0);position:relative}',
        '.ps-pc-fan__img--2{z-index:2;transform:rotate(-8deg) translateX(-52px) translateY(6px)}',
        '.ps-pc-fan__img--3{z-index:1;transform:rotate(8deg) translateX(52px) translateY(6px)}',
        '@media(min-width:820px){.ps-pc-fan{height:130px;margin:.4rem 0 .6rem}}',
        '@media(min-width:820px){.ps-pc-fan__img{width:80px;height:105px}}',
        '@media(min-width:820px){.ps-pc-fan__img--2{transform:rotate(-8deg) translateX(-42px) translateY(6px)}}',
        '@media(min-width:820px){.ps-pc-fan__img--3{transform:rotate(8deg) translateX(42px) translateY(6px)}}',
        /* nom */
        '.ps-pc-name{font-size:.88rem;font-weight:700;color:#1c2b1e;line-height:1.3;margin:0}',
        '.ps-pc-card--featured .ps-pc-name{color:#2d5a3d}',
        '.ps-pc-card--premium .ps-pc-name{color:#a07820}',
        /* tagline */
        '.ps-pc-tagline{font-size:.73rem;color:#5a6b5c;line-height:1.4;margin:.1rem 0 .1rem}',
        /* features */
        '.ps-pc-features{list-style:none;padding:0;margin:.3rem 0 0;display:flex;flex-direction:column;gap:.25rem}',
        '@media(min-width:560px){.ps-pc-features{flex-direction:column;gap:.2rem}}',
        '.ps-pc-features li{font-size:.67rem;color:#4a5c4c;padding-left:1.05em;position:relative;line-height:1.35}',
        '.ps-pc-features li::before{content:"\\2713";position:absolute;left:0;color:#1a7a50;font-weight:700}',
        '.ps-pc-card--featured .ps-pc-features li::before{color:#2d5a3d}',
        '.ps-pc-card--premium .ps-pc-features li::before{color:#c9a84c}',
        /* bouton */
        '.ps-pc-btn{margin-top:auto;padding:.5rem .6rem;border-radius:8px;border:none;font-size:.74rem;font-weight:700;cursor:pointer;text-align:center;width:100%;line-height:1.3;letter-spacing:.01em}',
        '.ps-pc-btn--free{background:#f3f0eb;color:#2d5a3d;border:1.5px solid #ddd8d0}',
        '.ps-pc-btn--free:hover{background:#e4f0e8;border-color:#2d5a3d}',
        '.ps-pc-btn--featured{background:#2d5a3d;color:#fff}',
        '.ps-pc-btn--featured:hover{background:#1a7a50}',
        '.ps-pc-btn--premium{background:#c9a84c;color:#fff}',
        '.ps-pc-btn--premium:hover{background:#b8943d}',
        /* panneau email */
        '.ps-pack-cards__email{margin-top:.7rem;padding:.7rem;background:#f7f5f1;border-radius:10px;display:none}',
        '.ps-pack-cards__email.is-open{display:block}',
        '.ps-pack-cards__email input[type=email]{width:100%;padding:.42rem .6rem;border:1.5px solid #d9d4cc;border-radius:7px;font-size:.8rem;margin-bottom:.4rem;box-sizing:border-box;outline:none}',
        '.ps-pack-cards__email input[type=email]:focus{border-color:#2d5a3d}',
        '.ps-pack-cards__email-submit{width:100%;padding:.48rem;background:#2d5a3d;color:#fff;border:none;border-radius:7px;font-size:.76rem;font-weight:700;cursor:pointer}',
        '.ps-pack-cards__email-submit:hover{background:#1a7a50}',
        '.ps-pack-cards__email-success{font-size:.78rem;color:#1a7a50;font-weight:600;text-align:center;padding:.3rem 0}'
      ].join('');
      document.head.appendChild(style);
    }

    var p1 = data.pack1 || {};
    var p2 = data.pack2 || {};
    var p3 = data.pack3 || {};

    var tabsHtml =
      '<div class="ps-pack-cards__tabs">' +
        '<button class="ps-pc-tab ps-pc-tab--free" data-pc-tab="free">' + _pcEsc(p1.badge || 'Essentiel') + '</button>' +
        '<button class="ps-pc-tab is-active" data-pc-tab="featured">' + _pcEsc(p2.badge || 'Optimisé') + '</button>' +
        '<button class="ps-pc-tab ps-pc-tab--premium" data-pc-tab="premium">' + _pcEsc(p3.badge || 'Autonome') + '</button>' +
      '</div>';

    var el = document.createElement('div');
    el.id = 'ps-pack-cards';
    el.className = 'ps-pack-cards';
    el.innerHTML =
      (data.label ? '<p class="ps-pack-cards__label">' + _pcEsc(data.label) + '</p>' : '') +
      tabsHtml +
      '<div class="ps-pack-cards__grid">' +
        _pcCard(p1, p1.variantId, 'free') +
        _pcCard(p2, p2.variantId, 'featured') +
        _pcCard(p3, p3.variantId, 'premium') +
      '</div>' +
      '<div class="ps-pack-cards__email" id="ps-pack-email">' +
        '<form data-pc-email-form novalidate>' +
          '<input type="email" placeholder="votre@email.com" autocomplete="email" required>' +
          '<button class="ps-pack-cards__email-submit" type="submit">Recevoir mon code</button>' +
        '</form>' +
        '<p class="ps-pack-cards__email-success" hidden>\u2713 Code envoy\u00e9 !</p>' +
      '</div>';

    anchor.parentNode.insertBefore(el, anchor);

    // Mobile tab switching — show featured by default
    var cards = { free: el.querySelector('.ps-pc-card--free'), featured: el.querySelector('.ps-pc-card--featured'), premium: el.querySelector('.ps-pc-card--premium') };
    
    function _pcRollbackCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartIconEl = document.querySelector('cart-icon');
          if (cartIconEl && typeof cartIconEl.renderCartBubble === 'function') {
            cartIconEl.renderCartBubble(cart.item_count || 0, false, false);
          }
        })
        .catch(function() {});
    }

    function showTab(mod) {
      Object.keys(cards).forEach(function(k) { if (cards[k]) cards[k].classList.remove('is-visible'); });
      if (cards[mod]) cards[mod].classList.add('is-visible');
      el.querySelectorAll('.ps-pc-tab').forEach(function(t) {
        t.classList.toggle('is-active', t.getAttribute('data-pc-tab') === mod);
        t.classList.toggle('ps-pc-tab--premium', t.getAttribute('data-pc-tab') === 'premium' && t.classList.contains('is-active'));
      });
    }
    showTab('featured');

    el.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-pc-email-form]');
      if (!form) return;
      e.preventDefault();
      var inp = form.querySelector('input[type="email"]');
      var email = inp ? inp.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (inp) inp.focus(); return; }
      var submit = form.querySelector('.ps-pack-cards__email-submit');
      if (submit) submit.disabled = true;
      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '\u2713');
      body.set('contact[email]', email);
      body.set('contact[tags]', 'newsletter,pack-offert-serre');
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        body: body.toString()
      }).catch(function(){}).finally(function() {
        form.hidden = true;
        var suc = el.querySelector('.ps-pack-cards__email-success');
        if (suc) suc.hidden = false;
      });
    });
  }

  function buildSummary() {
    if (summaryEl) return;
    // Ne s'affiche que sur la page produit
    var mainEl = document.querySelector('main[data-template]');
    if (!mainEl || !mainEl.getAttribute('data-template').startsWith('product')) return;

    var title = getMeta('summaryTitle') || 'Votre sélection';
    var subtitle = getMeta('summarySubtitle') || getMeta('productFeatureTitle') || 'Configuration optimisée pour votre jardin';
    summaryEl = document.createElement('div');
    summaryEl.className = 'ps-configurator-summary';
    summaryEl.innerHTML =
      '<div class="ps-configurator-summary__selection-area">' +
        '<div class="ps-configurator-summary__selection-content">' +
          '<div class="ps-configurator-summary__title">' + title + '</div>' +
          '<div class="ps-configurator-summary__subtitle">' + subtitle + '</div>' +
        '</div>' +
        '<div id="ps-summary-testimonial" hidden></div>' +
      '</div>' +
      '<div class="ps-configurator-summary__rows" id="ps-summary-rows"></div>' +
      '<div class="ps-configurator-summary__row ps-configurator-summary__qty-row" id="ps-summary-qty-row">' +
        '<span class="ps-configurator-summary__row-label">Quantit\u00e9</span>' +
        '<span class="ps-configurator-summary__row-value" id="ps-summary-qty">1</span>' +
      '</div>' +
      '<div class="ps-configurator-summary__row ps-configurator-summary__weight-row" id="ps-summary-weight-row" hidden>' +
        '<span class="ps-configurator-summary__row-label">Poids total</span>' +
        '<span class="ps-configurator-summary__row-value" id="ps-summary-weight">\u2014</span>' +
      '</div>' +
      '<div class="ps-configurator-summary__price">' +
        '<span class="ps-configurator-summary__price-label" id="ps-summary-price-label">Prix</span>' +
        '<span class="ps-configurator-summary__price-value" id="ps-summary-price">\u2014</span>' +
      '</div>';

    // Insérer AVANT le bloc buy-buttons (boutons Ajouter + Acheter)
    var anchor = document.querySelector('.buy-buttons-block')
      || document.querySelector('add-to-cart-component');
    if (!anchor) return;
    anchor.parentNode.insertBefore(summaryEl, anchor);

    window.__psQty = 1; // init shared qty
    try { initSummaryPriceData(); } catch(e) {}
    updateSummary();
    try { updateSummaryPriceDisplay(); } catch(e) {}
    // Injecter le testimonial si déjà calculé
    setTimeout(function () {
      if (window.__psApplySummaryTestimonial) window.__psApplySummaryTestimonial();
    }, 0);
  }

  function buildCrossSell() {
    if (document.getElementById('ps-cross-sell')) return;
    var dataEl = document.getElementById('ps-cross-sell-data');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent.trim()); } catch (e) { console.warn('[PS cross-sell] JSON parse error:', e); return; }
    if (!products || !products.length) return;

    // Formater le prix en devise du shop (copie du helper existant)
    function fmtCs(cents) {
      var fmt = window.__psFmt || (window.__psPriceCache && window.__psPriceCache.fmt) || '{{amount}} €';
      var cur = window.__psCur || '';
      if (typeof fmtMoney === 'function') return fmtMoney(cents, fmt, cur);
      return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
    }

    // Sélectionner le variant disponible le moins cher
    function pickVariant(p) {
      var variants = p.variants;
      if (!variants || !variants.length) return { id: p.variant_id, price: p.price, title: '' };
      if (variants.length === 1) return variants[0];

      // Prendre le variant du milieu (par prix) pour qu'il reste un upgrade à proposer en upsell
      var available = variants.filter(function (v) { return v.available !== false; });
      var pool = available.length ? available : variants;
      var sorted = pool.slice().sort(function (a, b) { return a.price - b.price; });
      return sorted[Math.floor((sorted.length - 1) / 2)];
    }

    // Vrai si le produit a plusieurs prix distincts
    function hasMultiplePrices(p) {
      if (!p.variants || p.variants.length <= 1) return false;
      var first = p.variants[0].price;
      return p.variants.some(function (v) { return v.price !== first; });
    }

    var pickedVariants = {}; // productId -> variant
    var cardsHtml = products.map(function (p, i) {
      var isRecommended = (i === 1);
      var variant = pickVariant(p);
      pickedVariants[p.id] = variant;
      var displayPrice = variant.price || p.price;
      var priceHtml = hasMultiplePrices(p)
        ? '<span class="ps-cs-card__price-from">Dès</span> ' + fmtCs(displayPrice)
        : fmtCs(displayPrice);
      var variantId = (variant && variant.id) || p.variant_id;
      var variantUrl = p.url + '?variant=' + variantId;

      return (
        '<div class="ps-cs-card' + (isRecommended ? ' ps-cs-card--recommended' : '') + '" data-ps-product-id="' + p.id + '">' +
          (isRecommended ? '<span class="ps-cs-card__badge">\u2b50 Recommand\u00e9</span>' : '') +
          '<a class="ps-cs-card__img-link" href="' + variantUrl + '" tabindex="-1">' +
            '<img class="ps-cs-card__img" src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" width="120" height="120" loading="lazy">' +
          '</a>' +
          '<div class="ps-cs-card__body">' +
            '<a class="ps-cs-card__title" href="' + variantUrl + '">' + p.title + '</a>' +
            (p.subtitle ? '<span class="ps-cs-card__subtitle">' + p.subtitle + '</span>' : '') +
            '<span class="ps-cs-card__price">' + priceHtml + '</span>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var el = document.createElement('div');
    el.id = 'ps-cross-sell';
    el.className = 'ps-cross-sell';
    el.innerHTML =
      '<p class="ps-cross-sell__label">Compl\u00e9tez votre commande</p>' +
      '<div class="ps-cross-sell__list">' + cardsHtml + '</div>';

    // Insérer après summaryEl si présent, sinon avant buy-buttons
    var anchor = document.querySelector('.buy-buttons-block') || document.querySelector('add-to-cart-component');
    if (!anchor) { console.warn('[PS cross-sell] no anchor found'); return; }
    if (summaryEl && summaryEl.parentNode) {
      summaryEl.parentNode.insertBefore(el, summaryEl.nextSibling);
    } else {
      anchor.parentNode.insertBefore(el, anchor);
    }

    // Injecter les product-form-component dans chaque carte
    // IMPORTANT : assigner variantInput.value APRÈS appendChild pour éviter que
    // connectedCallback (qui re-résout les refs) ne soit appelé après l'assignation
    var formsContainer = document.getElementById('ps-cross-sell-forms');
    products.forEach(function (p) {
      var card = el.querySelector('[data-ps-product-id="' + p.id + '"]');
      if (!card) return;
      if (!formsContainer) return;
      var wrapper = formsContainer.querySelector('.ps-csf-wrapper[data-product-id="' + p.id + '"]');
      if (!wrapper) return;
      var formComponent = wrapper.querySelector('product-form-component');
      if (!formComponent) return;

      // 1. Déplacer le composant dans la carte (déclenche disconnect + connect)
      card.appendChild(formComponent);

      // 2. Assigner l'ID de variant APRÈS connectedCallback
      var variant = pickedVariants[p.id];
      var variantId = (variant && variant.id) || p.variant_id;
      var variantInput = formComponent.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = String(variantId);

      // 3. Mettre à jour l'image fly-to-cart
      var atcComp = formComponent.querySelector('add-to-cart-component');
      var cardImg = card.querySelector('.ps-cs-card__img');
      if (atcComp && cardImg) atcComp.setAttribute('data-product-variant-media', cardImg.src);
    });

  }

  function updateSummary() {
    if (!summaryEl) return;
    var rowsEl = document.getElementById('ps-summary-rows');
    var priceEl = document.getElementById('ps-summary-price');
    if (!rowsEl || !priceEl) return;

    // Optional label map: custom.option_labels JSON {"Épaisseur Polycarbonate": "Épaisseur", ...}
    var labelsRaw = getMeta('optionLabels');
    var labelMap = {};
    if (labelsRaw) { try { labelMap = JSON.parse(labelsRaw); } catch (e) {} }

    var html = '';
    document.querySelectorAll('.variant-option--buttons').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;
      var rawName = legend.childNodes[0] ? legend.childNodes[0].textContent.trim() : legend.textContent.trim();
      var name = labelMap[rawName] || rawName.split(' ')[0]; // fallback: first word
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var value = checked ? checked.value : '\u2014';
      html +=
        '<div class="ps-configurator-summary__row">' +
          '<span class="ps-configurator-summary__row-label">' + name + '</span>' +
          '<span class="ps-configurator-summary__row-value">' + value + '</span>' +
        '</div>';
    });
    rowsEl.innerHTML = html;

    // Qty display — cherche dans le bloc standalone quantité OU dans add-to-cart
    var qtyInput = document.querySelector('.quantity-selector [ref="quantityInput"]')
      || document.querySelector('[ref="quantityInput"]');
    if (qtyInput) psSummaryQty = parseInt(qtyInput.value) || 1;
    var qtyEl = document.getElementById('ps-summary-qty');
    if (qtyEl) qtyEl.textContent = psSummaryQty;

    // Poids total = poids variant × quantité
    (function() {
      var weightRow = document.getElementById('ps-summary-weight-row');
      var weightEl = document.getElementById('ps-summary-weight');
      if (!weightRow || !weightEl) return;
      var weights = window.__pureserre_variants_weight;
      if (!weights) return;
      // Même méthode que l'IIFE de prix : radio coché avec data-variant-id
      var selectedRadio = document.querySelector('variant-picker input[type="radio"]:checked[data-variant-id]');
      var variantId = selectedRadio && String(selectedRadio.dataset.variantId);
      if (!variantId) {
        var hiddenInput = document.querySelector('product-form-component input[name="id"]')
          || document.querySelector('form[action="/cart/add"] input[name="id"]');
        variantId = hiddenInput && String(hiddenInput.value);
      }
      if (!variantId) return;
      var w = weights[String(variantId)];
      if (!w || w <= 0) { weightRow.hidden = true; return; }
      var total = w * psSummaryQty;
      weightEl.textContent = total >= 1000 ? Math.round(total / 1000) + ' kg' : total + ' g';
      weightRow.hidden = false;
    })();

    // Prix : initialisé depuis cache ou DOM
    try { initSummaryPriceData(); } catch(e) {}
    try { updateSummaryPriceDisplay(); } catch(e) {}
  }

  /* ---- Parallax hero ---- */
  /* ---- Barre certifications sous le testimonial ---- */
  function injectCertifBar() {
    var title = getMeta('certificationText');
    var link  = getMeta('certificationLink');
    if (!title) return;
    if (document.getElementById('ps-certif-bar')) return;

    var bar = document.createElement(link ? 'a' : 'span');
    bar.id = 'ps-certif-bar';
    if (link) { bar.href = link; bar.target = '_blank'; bar.rel = 'noopener noreferrer'; }
    bar.className = 'ps-certif-bar';
    bar.innerHTML =
      '<svg class="ps-certif-bar__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" width="13" height="13"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.6"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span>' + title.replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</span>';
    if (!document.getElementById('ps-certif-bar-css')) {
      var s = document.createElement('style');
      s.id = 'ps-certif-bar-css';
      s.textContent =
        '.ps-certif-bar{display:flex;align-items:center;gap:10px;font-size:0.8rem;font-weight:600;color:rgba(26,53,40,0.55);text-decoration:underline;text-underline-offset:3px;text-decoration-color:rgba(26,53,40,0.25);letter-spacing:0.01em;margin:0;padding:14px 16px;background:rgba(26,53,40,0.04);border-radius:10px;width:100%;box-sizing:border-box;transition:transform 0.35s cubic-bezier(0.22,1,0.36,1),color 0.2s,background 0.2s}' +
        'a.ps-certif-bar:hover{color:rgba(26,53,40,0.85);background:rgba(26,53,40,0.08);text-decoration-color:rgba(26,53,40,0.5);transform:translateY(-2px)}' +
        '.ps-certif-bar__icon{flex-shrink:0;width:16px;height:16px}';
      document.head.appendChild(s);
    }

    // Insérer avant le premier bloc .accordion (LIVRAISON, etc.)
    var accordion = document.querySelector('.product-details .accordion');
    if (accordion) {
      accordion.insertAdjacentElement('beforebegin', bar);
    } else {
      // Fallback : avant le bloc buy-buttons
      var buyBtn = document.querySelector('.buy-buttons-block') || document.querySelector('add-to-cart-component');
      if (buyBtn) buyBtn.insertAdjacentElement('beforebegin', bar);
    }
  }

  function initParallax() {
    var bg = document.querySelector('.product-collection-bg');
    if (!bg) return;
    var img = bg.querySelector('img');
    if (!img) return;

    function onScroll() {
      var rect = bg.getBoundingClientRect();
      if (rect.top > window.innerHeight || rect.bottom < 0) return;
      var progress = (-rect.top) / (window.innerHeight + rect.height);
      img.style.transform = 'translateY(' + (progress * 40) + 'px) scale(1.06)';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Init ---- */
  function init() {
    injectRecommendedBadges();
    injectOptionDescs();
    updateCardPrices();
    injectCertifBar();
    buildSummary();
    buildCrossSell();
    buildPackCards();

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.variant-picker__form')) {
        updateSummary();
        updateCardPrices();
      }
    });
    document.addEventListener('variant:update', function (e) {
      // Le thème re-rend le picker HTML — on réinjecte les hints/descs
      injectRecommendedBadges();
      injectOptionDescs();
      updateCardPrices();
      updateSummary();
      // Mise à jour directe poids via variant ID de l'event (fiable même si le DOM n'est pas encore à jour)
      var vid = e && e.detail && e.detail.resource && e.detail.resource.id;
      if (vid && window.__pureserre_variants_weight) {
        var weightRow = document.getElementById('ps-summary-weight-row');
        var weightEl = document.getElementById('ps-summary-weight');
        if (weightRow && weightEl) {
          var w = window.__pureserre_variants_weight[String(vid)];
          if (!w || w <= 0) { weightRow.hidden = true; }
          else {
            var total = w * (window.__psQty || psSummaryQty || 1);
            weightEl.textContent = total >= 1000 ? Math.round(total / 1000) + ' kg' : total + ' g';
            weightRow.hidden = false;
          }
        }
      }
    });

    document.addEventListener('quantity-selector:update', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer-component')) return;
      psSummaryQty = (e.detail && e.detail.quantity) || 1;
      window.__psQty = psSummaryQty; // partager avec price IIFE
      var qtyEl = document.getElementById('ps-summary-qty');
      if (qtyEl) qtyEl.textContent = psSummaryQty;
      // Mise à jour poids total
      (function() {
        var weightRow = document.getElementById('ps-summary-weight-row');
        var weightEl = document.getElementById('ps-summary-weight');
        if (!weightRow || !weightEl) return;
        var weights = window.__pureserre_variants_weight;
        if (!weights) return;
        var hiddenInput = document.querySelector('input[name="id"]');
        var variantId = hiddenInput && String(hiddenInput.value);
        if (!variantId) return;
        var w = weights[variantId];
        if (!w || w <= 0) { weightRow.hidden = true; return; }
        var total = w * psSummaryQty;
        weightEl.textContent = total >= 1000 ? Math.round(total / 1000) + ' kg' : total + ' g';
        weightRow.hidden = false;
      })();
      var stickyQtyEl = document.getElementById('ps-sticky-price-qty');
      if (stickyQtyEl) stickyQtyEl.textContent = psSummaryQty;
      updateSummaryPriceDisplay();
      // Sticky bar : prix unitaire courant × nouvelle quantité
      var unitPrice = window.__psUnitPrice || psSummaryUnitPrice;
      var fmt = window.__psFmt || psSummaryFmt;
      var cur = window.__psCur || psSummaryCur;
      if (unitPrice && fmt) {
        var total = unitPrice * psSummaryQty;
        var fmtTotal = fmtMoney(total, fmt, cur);
        document.querySelectorAll('.sticky-add-to-cart__price .price-item--regular, .sticky-add-to-cart__price .price').forEach(function (el) {
          el.textContent = fmtTotal;
        });
      }
    });

    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =====================================================
   Sticky bar — fermeture discrète + réapparition
   • Croix fine top-right, opacity 0.35 → discret
   • Réapparaît : changement variante OU scroll vers haut
   ===================================================== */
(function () {
  function getStickyBar() {
    return document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
  }

  var userDismissed = false;

  function dismissBar() {
    var bar = getStickyBar();
    if (bar) bar.classList.add('ps-sticky--dismissed');
  }

  function reshowBar() {
    if (userDismissed) return;
    var bar = getStickyBar();
    if (bar && bar.classList.contains('ps-sticky--dismissed')) {
      bar.classList.remove('ps-sticky--dismissed');
    }
  }

  function injectCloseBtn(bar) {
    if (bar.querySelector('.ps-sticky-close')) return;
    var btn = document.createElement('button');
    btn.className = 'ps-sticky-close';
    btn.setAttribute('aria-label', 'Fermer');
    btn.textContent = '✕';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      userDismissed = true;
      dismissBar();
    });
    bar.appendChild(btn);
  }

  function tryInject() {
    var bar = getStickyBar();
    if (bar) injectCloseBtn(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInject);
  } else {
    tryInject();
  }

  // Injection sur ajout dynamique (section renderer, téléportation)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var bar = node.matches && node.matches('[ref="stickyBar"]')
          ? node
          : node.querySelector && node.querySelector('[ref="stickyBar"]');
        if (bar) injectCloseBtn(bar);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Réapparition au changement de variante (l'utilisateur configure activement)
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.variant-picker__form')) return;
    userDismissed = false;
    reshowBar();
  });

  // Scroll : cache après avoir scrollé 240px vers le bas, réaffiche en remontant 80px
  var lastScrollY = window.scrollY;
  var scrollOrigin = window.scrollY;
  var scrollDir = null;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    var dir = y > lastScrollY ? 'down' : (y < lastScrollY ? 'up' : scrollDir);
    if (dir !== scrollDir) {
      // Changement de direction : fige l'origine au point de retournement
      scrollOrigin = lastScrollY;
      scrollDir = dir;
    }
    if (dir === 'down' && y - scrollOrigin >= 240) dismissBar();
    else if (dir === 'up' && scrollOrigin - y >= 80) reshowBar();
    lastScrollY = y;
  }, { passive: true });
})();

/* =========================================
   Search panel — mobile 2-step navigation + transition
   ========================================= */
(function () {
  var MOBILE_BP = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_BP;
  }

  function getPanel() {
    return document.querySelector('.predictive-search-results__inner--panel');
  }

  function showStep2(panel) {
    panel.classList.add('search-panel--step2');
    var btn = panel.querySelector('#search-panel-back-btn');
    if (btn) btn.hidden = false;
  }

  function showStep1(panel) {
    panel.classList.remove('search-panel--step2');
    var btn = panel.querySelector('#search-panel-back-btn');
    if (btn) btn.hidden = true;
  }

  function updateBackLabel(panel) {
    var btn = panel.querySelector('#search-panel-back-btn');
    if (!btn) return;
    var header = panel.querySelector('.pureserre-rv-header span');
    btn.textContent = (header ? '\u2190 ' + header.textContent : '\u2190 Retour');
  }

  /* Fade out products immediately, fade in once DOM changes */
  function buildSkeletonCard() {
    return '<li class="ps-skeleton-card" aria-hidden="true">'
      + '<div class="ps-skeleton-img"></div>'
      + '<div class="ps-skeleton-body">'
      + '<div class="ps-skeleton-line ps-skeleton-line--title"></div>'
      + '<div class="ps-skeleton-line ps-skeleton-line--title ps-skeleton-line--short"></div>'
      + '<div class="ps-skeleton-line ps-skeleton-line--price"></div>'
      + '</div>'
      + '</li>';
  }

  function showSkeleton() {
    var container = document.getElementById('predictive-search-products');
    if (!container) return;

    // Skeleton the header title
    var header = container.querySelector('.pureserre-rv-header');
    if (header) header.classList.add('ps-skeleton-header--loading');

    // Add progress bar
    var existing = container.querySelector('.ps-progress-bar');
    if (!existing) {
      var bar = document.createElement('div');
      bar.className = 'ps-progress-bar';
      container.insertBefore(bar, container.firstChild);
    }

    // Replace grid with skeleton cards
    var grid = container.querySelector('.pureserre-rv-grid');
    if (!grid) return;
    var count = grid.children.length || 4;
    var cards = '';
    for (var i = 0; i < Math.min(count, 6); i++) cards += buildSkeletonCard();
    grid.innerHTML = cards;
    grid.classList.add('pureserre-rv-grid--skeleton');
  }

  function clearSkeleton() {
    var container = document.getElementById('predictive-search-products');
    if (!container) return;
    var header = container.querySelector('.pureserre-rv-header');
    if (header) header.classList.remove('ps-skeleton-header--loading');
    var bar = container.querySelector('.ps-progress-bar');
    if (bar) {
      bar.classList.add('ps-progress-bar--done');
      setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 400);
    }
  }

  function fadeOutProducts() {
    var el = document.getElementById('predictive-search-products');
    if (el) {
      el.classList.add('ps-products--loading');
      el.classList.remove('ps-products--loaded');
    }
    showSkeleton();
  }

  function watchForMorphAndFadeIn() {
    var el = document.getElementById('predictive-search-products');
    if (!el) return;

    var safetyTimer = setTimeout(function () {
      observer.disconnect();
      clearSkeleton();
      el.classList.remove('ps-products--loading');
    }, 2500);

    var observer = new MutationObserver(function () {
      // After any DOM change, check if skeleton cards are gone
      // (morph may patch nodes in-place via attribute changes, not just addedNodes)
      var stillSkeleton = !!el.querySelector('.ps-skeleton-card');
      if (stillSkeleton) return; // morph hasn't replaced skeleton yet

      clearTimeout(safetyTimer);
      observer.disconnect();
      requestAnimationFrame(function () {
        clearSkeleton();
        el.classList.remove('ps-products--loading');
        el.classList.add('ps-products--loaded');
        setTimeout(function () { el.classList.remove('ps-products--loaded'); }, 400);
      });
    });

    // Watch childList AND attribute changes (morph may only mutate classes)
    observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var collBtn = e.target && e.target.closest && e.target.closest('.search-collection-btn');
    if (collBtn) {
      // Fade out immediately for all screen sizes
      fadeOutProducts();
      watchForMorphAndFadeIn();

      if (!isMobile()) return;

      var panel = getPanel();
      if (!panel) return;
      setTimeout(function () {
        updateBackLabel(panel);
        showStep2(panel);
      }, 80);
      return;
    }

    // Back button → go to step 1 (mobile only)
    if (!isMobile()) return;
    var backBtn = e.target && e.target.closest && e.target.closest('#search-panel-back-btn');
    if (backBtn) {
      var panel = getPanel();
      if (panel) showStep1(panel);
    }
  });

  // Reset to step 1 whenever the search modal closes
  document.addEventListener('dialog:close', function () {
    var panel = getPanel();
    if (panel) showStep1(panel);
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('search-modal__content')) {
      var panel = getPanel();
      if (panel) showStep1(panel);
    }
  }, true);
})();

/* Collection nav — hide siblings on click then navigate */
(function () {
  // On page load: Liquid renders aria-current="false" on inactive links.
  // kinetic.css uses nav a[aria-current] (attribute presence, any value) so
  // "false" also triggers the green underline. Remove the attribute on all
  // links that are not truly current.
  function cleanCollectionNav() {
    document.querySelectorAll('.collection-links__link[aria-current="false"]').forEach(function (l) {
      l.removeAttribute('aria-current');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanCollectionNav);
  } else {
    cleanCollectionNav();
  }
  // Re-run after each view-transition navigation so the correct link is marked active
  window.addEventListener('pagereveal', cleanCollectionNav);

  // Ensure sort_by is always in collection links so the head redirect never fires.
  // The redirect (location.replace) cancels any in-progress view transition.
  function ensureSortParam(href) {
    try {
      var url = new URL(href, location.origin);
      if (url.pathname.indexOf('/collections/') === 0 && !url.searchParams.has('sort_by')) {
        url.searchParams.set('sort_by', 'price-descending');
        return url.pathname + '?' + url.searchParams.toString();
      }
    } catch (err) {}
    return href;
  }

  // Patch all collection links as soon as DOM is ready
  function patchCollectionLinks() {
    document.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href) a.setAttribute('href', ensureSortParam(href));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCollectionLinks);
  } else {
    patchCollectionLinks();
  }

  // Re-patch when the header drawer opens (menu links are lazy-inserted)
  document.addEventListener('click', function (e) {
    var toggle = e.target && e.target.closest && e.target.closest('[aria-controls="header-drawer"], header-drawer summary, .header-actions__action--menu');
    if (toggle) {
      requestAnimationFrame(function () {
        patchCollectionLinks();
      });
    }
  });

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.collection-links__link[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href[0] === '#') return;
    var component = link.closest('collection-links-component');
    if (!component) return;

    var allLinks = component.querySelectorAll('.collection-links__link');

    // Force visual state immediately
    allLinks.forEach(function (l) {
      if (l === link) {
        l.setAttribute('aria-current', 'true');
      } else {
        l.setAttribute('aria-current', 'false');
      }
    });

    // Freeze the component completely so pointerenter/pointerleave can't undo this.
    // select() calls #updateSelectedLink() (private) which resets aria-current.
    // clearSelections() resets all to false on pointerleave.
    // Both are public instance methods — overridable from outside.
    if (typeof component.select === 'function') {
      component.select = function () {};
    }
    if (typeof component.clearSelections === 'function') {
      component.clearSelections = function () {};
    }

    // Native navigation proceeds
  });
})();

/* =====================================================
   Collection subnav — centre le pill actif sur mobile
   ===================================================== */
(function () {
  function scrollActiveNavPill() {
    var nav = document.querySelector('.collection-subnav');
    if (!nav) return;
    var active = nav.querySelector('.collection-subnav__link--active');
    if (!active) return;
    var navWidth = nav.offsetWidth;
    var pillLeft = active.offsetLeft;
    var pillWidth = active.offsetWidth;
    var scrollTarget = pillLeft - (navWidth / 2) + (pillWidth / 2);
    var target = Math.max(0, scrollTarget);

    /* Centre d'abord instantanément, puis micro-animation hint */
    nav.scrollLeft = target;

    /* Hint : avance de 48px puis revient — montre qu'il y a quelque chose à droite */
    var maxScroll = nav.scrollWidth - nav.clientWidth;
    if (maxScroll > 10) {
      setTimeout(function () {
        nav.scrollTo({ left: Math.min(target + 48, maxScroll), behavior: 'smooth' });
        setTimeout(function () {
          nav.scrollTo({ left: target, behavior: 'smooth' });
        }, 420);
      }, 350);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollActiveNavPill);
  } else {
    scrollActiveNavPill();
  }
})();

/* =====================================================
   Catalogue carousel — progress bar + carte active
   ===================================================== */
(function () {
  function initCatalogueDots() {
    var section = document.querySelector('[id$="__catalogue"]');
    if (!section) return;
    var dots = section.querySelectorAll('.catalogue-dot');
    if (!dots.length) return;

    function setActive(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('catalogue-dot--active', i === idx);
      });
    }

    /* État initial : première barre active */
    setActive(0);

    /* Le thème dispatche 'slideshow:select' (bubbles: true) sur slideshow-component
       à chaque changement de slide (scroll, swipe, flèches, autoplay).
       event.detail.index = index 0-basé de la slide courante. */
    section.addEventListener('slideshow:select', function (e) {
      setActive(e.detail.index);
    });
  }

  initCatalogueDots();
})();

/* =====================================================
   Nav active state — page produit
   Active le lien de collection correspondant dans le
   menu principal quand on est sur une page produit.
   Priorité :
     1. Handle de collection extrait de l'URL
        (/collections/{handle}/products/...)
     2. Fallback : premier lien dont le href contient
        "/collections/" et qui correspond à une
        collection du produit via ShopifyAnalytics
   ===================================================== */
(function () {
  function activateNavLink() {
    // Uniquement sur les pages produit
    var path = window.location.pathname;
    var isProduct = path.indexOf('/products/') !== -1;
    if (!isProduct) return;

    var collectionHandle = null;

    // Cas 1 : /collections/{handle}/products/{slug}
    var match = path.match(/\/collections\/([^/]+)\/products\//);
    if (match) {
      collectionHandle = match[1];
    }

    // Cas 2 : pas de collection dans l'URL — cherche dans ShopifyAnalytics
    if (!collectionHandle) {
      try {
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        var collections = meta && meta.product && meta.product.collections;
        if (collections && collections.length) {
          collectionHandle = collections[0].handle || collections[0];
        }
      } catch (e) {}
    }

    // Retire l'état actif actuel du nav
    function clearActive() {
      document.querySelectorAll('.menu-list__link[aria-current="page"], .menu-list__link--active').forEach(function (el) {
        el.removeAttribute('aria-current');
        el.classList.remove('menu-list__link--active');
      });
    }

    // Active le bon lien nav
    function markActive(link) {
      clearActive();
      link.setAttribute('aria-current', 'page');
      link.classList.add('menu-list__link--active');
    }

    // Cherche le lien nav correspondant au handle de collection
    if (collectionHandle) {
      var navLink = document.querySelector('.menu-list__link[href*="/collections/' + collectionHandle + '"]');
      if (navLink) { markActive(navLink); return; }
    }

    // Fallback ultime : active le lien "L'Eden" (texte)
    document.querySelectorAll('.menu-list__link').forEach(function (el) {
      var text = el.textContent.trim().toLowerCase();
      if (text === "l'eden" || text === 'eden' || text === "l'eden") {
        markActive(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activateNavLink);
  } else {
    activateNavLink();
  }
})();

/* =====================================================
   Nav active state — pages /apps/
   Active le lien nav dont le href contient le chemin
   courant quand on est sur une page d'app Shopify.
   ===================================================== */
(function () {
  var path = window.location.pathname;
  if (path.indexOf('/apps/') === -1) return;

  function activate() {
    var link = document.querySelector('.menu-list__link[href*="' + path + '"]');
    if (!link) {
      // fallback : cherche par préfixe (ex: /apps/suivi-de-commande)
      var slug = path.split('/apps/')[1];
      if (slug) link = document.querySelector('.menu-list__link[href*="/apps/' + slug.split('/')[0] + '"]');
    }
    if (!link) return;
    document.querySelectorAll('.menu-list__link[aria-current="page"], .menu-list__link--active').forEach(function (el) {
      el.removeAttribute('aria-current');
      el.classList.remove('menu-list__link--active');
    });
    link.setAttribute('aria-current', 'page');
    link.classList.add('menu-list__link--active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate);
  } else {
    activate();
  }
})();

/* =====================================================
   Offre accessoire — popup flottant
   ===================================================== */
(function () {
  var STORAGE_KEY = 'ps-offre-acc-done';

  function init() {
    var section = document.getElementById('offre-acc-root');

    // Téléporter hors de shopify-section pour que position:fixed marche
    if (section && section.parentElement !== document.body) {
      document.body.appendChild(section);
    }
    // Sur desktop: déplacer le bouton fermer dans .offre-acc__inner pour qu'il se positionne par rapport au modal
    if (section) {
      var closeBtn2 = section.querySelector('.offre-acc__close');
      var inner2 = section.querySelector('.offre-acc__inner');
      if (closeBtn2 && inner2 && closeBtn2.parentElement === section) {
        if (window.innerWidth >= 750) {
          inner2.insertBefore(closeBtn2, inner2.firstChild);
        }
      }
    }

    // Crée le bouton flottant uniquement si un bundle claimable existe sur la page
    var claimableBtn = document.querySelector('[data-bundle-open-offre][data-popup-claimable="true"]');
    var triggerLabel = claimableBtn
      ? (claimableBtn.dataset.popupTitle || (section && section.dataset.triggerLabel) || 'Offre accessoire')
      : ((section && section.dataset.triggerLabel) || 'Offre accessoire');

    var triggerBtn = document.createElement('button');
    triggerBtn.className = 'offre-acc-trigger';
    triggerBtn.type = 'button';
    triggerBtn.setAttribute('aria-label', triggerLabel);
    triggerBtn.innerHTML = '<span class="offre-acc-trigger__label">' + triggerLabel + '</span>';
    triggerBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Si un bundle claimable est sur la page, simuler un clic dessus pour pré-remplir le popup
      var cb = document.querySelector('[data-bundle-open-offre][data-popup-claimable="true"]');
      if (cb) { cb.click(); return; }
      var s = document.getElementById('offre-acc-root');
      if (s) {
        s.classList.add('offre-acc--open');
        s.removeAttribute('aria-hidden');
        if (window.innerWidth <= 749) {
          setTimeout(function () {
            var car = s.querySelector('[data-offre-carousel]');
            var codeSlide = s.querySelector('[data-offre-slide-code]');
            var slides = car ? Array.from(car.querySelectorAll('.offre-acc__slide')) : [];
            if (codeSlide) codeSlide.classList.remove('offre-acc__step--hidden');
            slides.forEach(function (sl, i) { sl.classList.toggle('is-active', i === 1); });
            var dots2 = s.querySelectorAll('[data-offre-dot]');
            dots2.forEach(function (d) {
              d.classList.toggle('offre-acc__dot--active', parseInt(d.dataset.offreDot, 10) === 1);
            });
          }, 60);
        }
      }
    });

    // N'ajouter le bouton que si bundle claimable présent (ou toujours sur page produit)
    triggerBtn.classList.add('offre-acc-trigger--sticky', 'offre-acc-trigger--hidden');
    // Masquer définitivement si pas de bundle claimable sur la page
    if (!claimableBtn) {
      triggerBtn.classList.add('offre-acc-trigger--no-bundle');
    }
    document.body.appendChild(triggerBtn);

    var MIN_SCROLL = 300;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        if (window.scrollY >= MIN_SCROLL && !triggerBtn.classList.contains('offre-acc-trigger--no-bundle')) {
          triggerBtn.classList.remove('offre-acc-trigger--hidden');
        } else {
          triggerBtn.classList.add('offre-acc-trigger--hidden');
        }
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // Vérifier l'état initial au cas où la page chargerait scrollée
    onScroll();

    if (!section) return;

    var stepConfig = section.querySelector('.offre-acc__step--config');
    var stepForm   = section.querySelector('[data-offre-slide-form]');
    var stepCode   = section.querySelector('[data-offre-slide-code]');
    var carousel   = section.querySelector('[data-offre-carousel]');
    var dots       = section.querySelectorAll('[data-offre-dot]');
    var prevBtn    = section.querySelector('[data-offre-prev]');
    var nextBtn2   = section.querySelector('[data-offre-next]');
    var closeBtn   = section.querySelector('[data-offre-close]');
    var backdrop   = section.querySelector('[data-offre-backdrop]');
    var form       = section.querySelector('[data-offre-form]');
    var errorEl    = section.querySelector('[data-offre-error]');
    var copyBtn    = section.querySelector('[data-offre-copy]');
    var copyLbl    = section.querySelector('[data-offre-copy-label]');

    function show(el) { if (!el) return; el.classList.remove('offre-acc__step--hidden'); el.removeAttribute('aria-hidden'); }
    function hide(el) { if (!el) return; el.classList.add('offre-acc__step--hidden'); el.setAttribute('aria-hidden', 'true'); }

    // ── Carousel helpers ──────────────────────────────────────────────────────
    function isMobile() { return window.innerWidth <= 749; }

    function getSlides() {
      return carousel ? Array.from(carousel.querySelectorAll('.offre-acc__slide')) : [];
    }

    var _currentIdx = 1; // start on form slide

    function goToSlide(idx) {
      var slides = getSlides();
      if (!slides[idx]) return;
      if (isMobile()) {
        // Mobile : show/hide via is-active
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      } else {
        // Desktop : scroll-based
        var s = slides[idx];
        var left = s.offsetLeft - (carousel.clientWidth - s.clientWidth) / 2;
        carousel.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
      _currentIdx = idx;
      updateDots(idx);
    }

    function currentSlideIdx() {
      if (!carousel) return _currentIdx;
      if (isMobile()) return _currentIdx;
      var slides = getSlides();
      var midX = carousel.scrollLeft + carousel.clientWidth / 2;
      var closest = _currentIdx;
      var closestDist = Infinity;
      slides.forEach(function (s, i) {
        var dist = Math.abs((s.offsetLeft + s.clientWidth / 2) - midX);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    function updateDots(idx) {
      dots.forEach(function (d) {
        var i = parseInt(d.dataset.offreDot, 10);
        d.classList.toggle('offre-acc__dot--active', i === idx);
      });
      // Update arrow edge state
      if (prevBtn) prevBtn.toggleAttribute('data-edge', idx === 0);
      if (nextBtn2) nextBtn2.toggleAttribute('data-edge', idx === getSlides().length - 1);
    }

    function scrollToSlide(idx) {
      goToSlide(idx);
    }

    function initCarouselMobile() {
      if (!isMobile() || !carousel) return;
      // Show code slide (remove desktop hidden class)
      if (stepCode) stepCode.classList.remove('offre-acc__step--hidden');
      // Activate middle slide (form)
      goToSlide(1);
    }

    // Dot clicks
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        scrollToSlide(parseInt(d.dataset.offreDot, 10));
      });
    });

    // Prev / Next arrows
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToSlide(currentSlideIdx() - 1); });
    if (nextBtn2) nextBtn2.addEventListener('click', function () { scrollToSlide(currentSlideIdx() + 1); });

    // Update dots on scroll
    if (carousel) {
      var scrollTimer;
      carousel.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { updateDots(currentSlideIdx()); }, 60);
      }, { passive: true });
    }

    // Sync selected state on config option click
    if (stepConfig) {
      stepConfig.addEventListener('click', function (e) {
        var option = e.target.closest('.offre-config__option');
        if (!option) return;
        var group = option.dataset.configGroup;
        var siblings = stepConfig.querySelectorAll('[data-config-group="' + group + '"]');
        siblings.forEach(function (el) { el.classList.remove('offre-config__option--selected'); });
        option.classList.add('offre-config__option--selected');
        var radio = option.querySelector('.offre-config__radio');
        if (radio) radio.checked = true;
      });

      var nextBtn = stepConfig.querySelector('[data-offre-config-next]');
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          hide(stepConfig);
          show(stepForm);
          var input = section.querySelector('input[type="email"]');
          if (input) setTimeout(function () { input.focus(); }, 80);
        });
      }
    }

    function closeModal() {
      var inner = section.querySelector('.offre-acc__inner');
      if (inner) { inner.style.transition = ''; inner.style.transform = ''; }
      section.classList.remove('offre-acc--open');
      section.setAttribute('aria-hidden', 'true');
    }

    function initSwipeToClose() {
      if (!isMobile()) return;
      var inner = section.querySelector('.offre-acc__inner');
      var handle = section.querySelector('.offre-acc__drag-handle');
      if (!inner || !handle || handle._swipeInit) return;
      handle._swipeInit = true;

      var startY = 0;
      var lastY = 0;
      var active = false;
      var THRESHOLD = 60;

      handle.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY;
        lastY = startY;
        active = true;
        inner.style.transition = 'none';
      }, { passive: true });

      handle.addEventListener('touchmove', function (e) {
        if (!active) return;
        lastY = e.touches[0].clientY;
        var delta = lastY - startY;
        if (delta > 0) inner.style.transform = 'translateY(' + delta + 'px)';
      }, { passive: true });

      handle.addEventListener('touchend', function () {
        if (!active) return;
        active = false;
        var delta = lastY - startY;
        if (delta > THRESHOLD) {
          closeModal();
        } else {
          inner.style.transition = '';
          inner.style.transform = '';
        }
      });
    }

    function initScrollHint() {
      if (!isMobile()) return;
      var inner = section.querySelector('.offre-acc__inner');
      if (!inner) return;
      // Append hint to section (the overlay), not inside the scroll container
      var hint = section.querySelector('.offre-acc__scroll-hint');
      if (!hint) {
        hint = document.createElement('div');
        hint.className = 'offre-acc__scroll-hint';
        hint.innerHTML = '<span class="offre-acc__scroll-hint-arrow"><svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 4v14M4 12l7 7 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        section.appendChild(hint);
      }
      hint.classList.remove('offre-acc__scroll-hint--hidden');
      function updateHint() {
        var canScroll = inner.scrollHeight > inner.clientHeight + 20;
        var atBottom = inner.scrollTop + inner.clientHeight >= inner.scrollHeight - 12;
        hint.classList.toggle('offre-acc__scroll-hint--hidden', !canScroll || atBottom);
      }
      // Reset scroll to top each open, then check after layout settles
      inner.scrollTop = 0;
      setTimeout(updateHint, 150);
      inner.removeEventListener('scroll', inner._scrollHintListener);
      inner._scrollHintListener = updateHint;
      inner.addEventListener('scroll', updateHint, { passive: true });
    }

    function openModal() {
      section.classList.add('offre-acc--open');
      section.removeAttribute('aria-hidden');
      if (isMobile()) {
        setTimeout(initCarouselMobile, 60);
        setTimeout(initScrollHint, 80);
        setTimeout(initSwipeToClose, 100);
      }
    }

    // Expose globally so external callers (smart-upsell, configurateur-inline, etc.)
    // can open the popup and get the mobile is-active treatment
    window._psOpenOffre = openModal;

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    // Tout bouton [data-offre-open] dans la page ouvre le popup
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-offre-open]');
      if (!opener) return;
      e.preventDefault();
      openModal();
    });

    if (backdrop) backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && section.classList.contains('offre-acc--open')) closeModal();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var phoneInput = form.querySelector('input[type="tel"]');
        var email = emailInput ? emailInput.value.trim() : '';
        var phone = phoneInput ? phoneInput.value.trim() : '';

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          show(errorEl);
          if (emailInput) emailInput.focus();
          return;
        }
        hide(errorEl);

        var submitBtn = form.querySelector('.offre-acc__submit');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('offre-acc__submit--loading');
        }

        var body = new URLSearchParams();
        body.set('form_type', 'customer');
        body.set('utf8', '\u2713');
        body.set('contact[email]', email);
        if (phone) body.set('contact[phone]', phone);
        body.set('contact[tags]', 'newsletter,offre-accessoire');

        // Resolve claimable bundle data before fetch
        var atcBtn = section.querySelector('[data-offre-bundle-atc]');
        var claimVariantId = atcBtn && atcBtn.dataset.offreBundleVariant ? parseInt(atcBtn.dataset.offreBundleVariant, 10) : null;
        var codeElForClaim = section.querySelector('[data-offre-code]');
        var claimCode = codeElForClaim ? codeElForClaim.textContent.trim() : '';

        function revealCode() {
          try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch(err) {}
          if (isMobile()) {
            show(stepCode);
            scrollToSlide(2);
          } else {
            hide(stepForm);
            show(stepCode);
          }
          if (triggerBtn) triggerBtn.style.display = 'none';
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('offre-acc__submit--loading');
          }
        }

        function addToCartAndReveal() {
          if (!claimVariantId) { revealCode(); return; }
          // Blindage : empêche le cart drawer de s'ouvrir pendant tout le flow
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer) { try { drawer.showDialog = function() { return Promise.resolve(); }; } catch(e) {} }

          var discountProm = claimCode
            ? fetch('/discount/' + encodeURIComponent(claimCode), { redirect: 'manual' }).catch(function () {})
            : Promise.resolve();
          discountProm.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: claimVariantId, quantity: 1 })
            });
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw d; });
            return fetch('/cart.js').then(function (r2) { return r2.json(); });
          }).then(function (cart) {
            // Mettre à jour le compteur — cart-icon (pas cart-icon-component)
            var cartIcon = document.querySelector('cart-icon');
            if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
              cartIcon.renderCartBubble(cart.item_count, false, true);
            }
          }).catch(function (err) { console.error('[offre] claimable ATC error', err); })
          .finally(function() {
            revealCode();
            // Restaure showDialog après un tick pour laisser les handlers sync se terminer
            setTimeout(function() {
              if (drawer) { try { delete drawer.showDialog; } catch(e) {} }
            }, 300);
          });
        }

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
          body: body.toString()
        }).catch(function () {}).finally(addToCartAndReveal);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = section.querySelector('[data-offre-code]');
        if (!codeEl) return;
        var code = codeEl.textContent.trim();
        var done = function () {
          if (copyLbl) {
            copyLbl.textContent = 'Copi\u00e9 !';
            setTimeout(function () { copyLbl.textContent = 'Copier'; }, 2000);
          }
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.cssText = 'position:absolute;opacity:0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          done();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;(function () {
  function initDots(track, itemSelector) {
    var items = Array.prototype.slice.call(track.querySelectorAll(itemSelector));
    if (items.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'carousel-dots';
    track.parentNode.insertBefore(wrap, track.nextSibling);

    var dots = items.map(function (item, i) {
      var btn = document.createElement('button');
      btn.className = 'carousel-dot' + (i === 0 ? ' carousel-dot--active' : '');
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', 'Slide ' + (i + 1));
      btn.addEventListener('click', function () {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      wrap.appendChild(btn);
      return btn;
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          var idx = items.indexOf(entry.target);
          if (idx !== -1) {
            dots.forEach(function (d) { d.classList.remove('carousel-dot--active'); });
            dots[idx].classList.add('carousel-dot--active');
          }
        }
      });
    }, { root: track, threshold: 0.5 });

    items.forEach(function (item) { observer.observe(item); });
  }

  function setupDots() {
    if (window.innerWidth >= 750) return;

    var upsellGrid = document.querySelector('.smart-upsell__grid');
    if (upsellGrid) initDots(upsellGrid, '.smart-upsell__item');

    var temoGrid = document.querySelector('.temoignages__grid');
    if (temoGrid) initDots(temoGrid, '.temoignage');

    var guideGrid = document.querySelector('.guide-choix__grid');
    if (guideGrid) initDots(guideGrid, '.guide-choix__card');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDots);
  } else {
    setupDots();
  }
})();

// =========================================================
// Header menu lock — empêche le flash du menu pendant les
// opérations panier (ajout, suppression, changement de qté)
// =========================================================
(function () {
  var header = null;
  var unlockTimer = null;

  function lockMenu() {
    if (!header) header = document.getElementById('header-component');
    if (!header) return;
    header.classList.add('ps-menu-locked');
    clearTimeout(unlockTimer);
    // Sécurité : déverrouille après 3s max si cart:update ne fire pas
    unlockTimer = setTimeout(unlockMenu, 3000);
  }

  function unlockMenu() {
    clearTimeout(unlockTimer);
    if (!header) return;
    header.classList.remove('ps-menu-locked');
  }

  // ATC depuis product-form
  document.addEventListener('submit', function (e) {
    if (e.target.closest('product-form-component form')) lockMenu();
  });

  // Suppression / changement de qté depuis le panier
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('cart-items-component [data-line]') ||
      e.target.closest('[data-cart-remove]') ||
      e.target.closest('cart-items-component quantity-selector-component')
    ) {
      lockMenu();
    }
  });

  // Déverrouille dès que le panier a fini de se mettre à jour
  document.addEventListener('cart:update', function () {
    // Légère attente pour laisser le DOM se stabiliser avant le re-render
    setTimeout(unlockMenu, 300);
  });
})();

// =========================================================
// Bundle Reco Modal — ouvre une modale avec la section
// bundle-recommandations après un ajout au panier si :
//   1. La section .bundle-reco est présente sur la page
//   2. Le produit n'a pas ses propres bundle_products (.offre-acc absent)
//   3. La session n'a pas encore vu cette modale
// =========================================================
(function () {
  var SESSION_KEY = 'ps_bundle_reco_seen';
  var modal = null;

  function getRecoSection() {
    return document.querySelector('.bundle-reco');
  }

  function hasSeen() {
    try { return !!sessionStorage.getItem(SESSION_KEY); } catch (e) { return false; }
  }

  function markSeen() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  function buildModal() {
    if (modal) return modal;

    var el = document.createElement('div');
    el.className = 'bundle-reco-modal';
    el.id = 'bundle-reco-modal';
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('role', 'dialog');

    el.innerHTML =
      '<div class="bundle-reco-modal__backdrop" data-brm-backdrop></div>' +
      '<div class="bundle-reco-modal__scroll-wrap">' +
        '<div class="bundle-reco-modal__dialog">' +
          '<button class="bundle-reco-modal__close" type="button" data-brm-close aria-label="Fermer">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<div class="bundle-reco-modal__content"></div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(el);

    // Scroll fade logic
    var scrollWrap = el.querySelector('.bundle-reco-modal__scroll-wrap');
    function updateScrollFade() {
      if (!scrollWrap) return;
      var atBottom = scrollWrap.scrollHeight - scrollWrap.scrollTop <= scrollWrap.clientHeight + 20;
      scrollWrap.classList.toggle('brm--at-end', atBottom);
    }
    if (scrollWrap) scrollWrap.addEventListener('scroll', updateScrollFade, { passive: true });

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-brm-close]') || e.target.closest('[data-brm-backdrop]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    modal = el;
    return modal;
  }

  function openModal() {
    var section = getRecoSection();
    if (!section) return;

    var m = buildModal();
    var content = m.querySelector('.bundle-reco-modal__content');

    content.innerHTML = '';
    content.appendChild(section.cloneNode(true));

    // Truncate feature lists: show first item only + "+N autres" (clickable expand)
    content.querySelectorAll('.bundle-card__features').forEach(function(ul) {
      var items = ul.querySelectorAll('li');
      var total = items.length;
      if (total <= 1) return;
      for (var i = 1; i < total; i++) { items[i].style.display = 'none'; }
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'bundle-features-more';
      more.textContent = '+' + (total - 1) + ' autres';
      more.addEventListener('click', function() {
        var expanded = ul.classList.toggle('bundle-features--expanded');
        if (expanded) {
          for (var i = 1; i < total; i++) { items[i].style.display = ''; }
          more.style.display = 'none';
        }
      });
      ul.after(more);
    });

    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    markSeen();
    // Reset scroll + update fade
    var sw = m.querySelector('.bundle-reco-modal__scroll-wrap');
    if (sw) { sw.scrollTop = 0; sw.classList.remove('brm--at-end'); }

    // Sur mobile : scroll horizontal vers la card avec badge (top label)
    requestAnimationFrame(function () {
      var grid = m.querySelector('.bundle-reco__grid');
      var highlight = grid && (grid.querySelector('.bundle-card--with-badge') || grid.querySelector('.bundle-card--highlight'));
      if (grid && highlight) {
        var offset = highlight.offsetLeft - (grid.offsetWidth / 2) + (highlight.offsetWidth / 2);
        grid.scrollLeft = offset;
      }
    });
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('product-form-component form');
    if (!form) return;
    console.log(e.target.closest('.bundle-card'))
    // Ne déclencher que sur un vrai ATC (pas un bundle-card ou un cross-sell qui ont leur propre handler)
    if (e.target.closest('.bundle-card')) return;
    if (e.target.closest('#ps-cross-sell')) return;

    if (hasSeen()) return;
    if (!getRecoSection()) return;
    var bundleBtn = document.querySelector('[data-bundle-open-offre]');
    var bundleBtnOutsideReco = bundleBtn && !bundleBtn.closest('.bundle-reco');
    if (bundleBtnOutsideReco) return;
    // Si une card avec top label a un bouton offre-acc, l'ouvrir directement
    var badgeCard = document.querySelector('.bundle-reco .bundle-card--with-badge');
    var offreBtn = badgeCard && badgeCard.querySelector('[data-bundle-open-offre]');
    if (offreBtn && window._psOpenOffre) {
      setTimeout(function () {
        offreBtn.dataset.fromAtc = 'true';
        offreBtn.click();
        delete offreBtn.dataset.fromAtc;
      }, 500);
    } else {
      setTimeout(openModal, 500);
    }
  });
})();

/* ── Variant Testimonials ─────────────────────────────────────────────────── *
 * Affiche le témoignage associé au variant sélectionné.
 * Les blocs `variant-testimonial` sont rendus en HTML caché (hidden).
 * Le bloc `pi-testimonial` (défaut) a data-pi-testimonial-default="true".
 * ─────────────────────────────────────────────────────────────────────────── */
(function () {
  function initVariantTestimonials() {
    var defaultFig = document.querySelector('.pi-temoignage[data-pi-testimonial-default]');
    var variantFigs = Array.from(document.querySelectorAll('.pi-temoignage[data-variant-testimonial-id]'));

    if (!variantFigs.length) return; // aucun témoignage par variant configuré

    // Initialise les toggles voir plus/moins sur les figures variantes
    variantFigs.forEach(function (fig) {
      fig.querySelectorAll('.pi-temoignage__toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var short = fig.querySelector('.pi-temoignage__short');
          var full = fig.querySelector('.pi-temoignage__full');
          var expanded = short.hidden;
          short.hidden = !expanded;
          full.hidden = expanded;
        });
      });
    });

    function showForVariant(variantId) {
      var id = String(variantId);
      var matched = null;
      variantFigs.forEach(function (fig) {
        var isMatch = fig.dataset.variantTestimonialId === id;
        fig.hidden = !isMatch;
        if (isMatch) matched = fig;
      });
      // Fallback sur le témoignage par défaut si aucun variant ne correspond
      if (defaultFig) defaultFig.hidden = matched !== null;
    }

    // État initial : variant sélectionné au chargement de la page
    var initialInput = document.querySelector('.variant-picker__form input[type="radio"]:checked');
    if (initialInput && initialInput.dataset.variantId) {
      showForVariant(initialInput.dataset.variantId);
    }

    // Changement de variant (radio direct avec data-variant-id)
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.variant-picker__form')) return;
      var variantId = e.target.dataset && e.target.dataset.variantId;
      if (!variantId) return;
      showForVariant(variantId);
    });

    // Changement de variant (event thème — multi-options, variant résolu côté serveur)
    document.addEventListener('variant:update', function (e) {
      var vid = e && e.detail && e.detail.resource && e.detail.resource.id;
      if (vid) showForVariant(String(vid));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantTestimonials);
  } else {
    initVariantTestimonials();
  }
})();

/* ── Variant Card Metafields ─────────────────────────────────────────────────
 * Quand une variante est sélectionnée, si elle possède les metafields custom :
 *   card_image       → remplace la 1re image de la galerie
 *   card_title       → remplace le titre produit (h1 + sticky bar)
 *   card_testimonial → affiche un témoignage sous le configurateur
 * Data source : <script id="ps-variant-card-mf">
 * ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var mfData = null;
  var origTitle = null;
  var origImgSrc = null;
  var origImgSrcset = null;
  var hasCustomImg = false;
  var _hasBundle = null; // null = not yet determined

  function loadData() {
    if (mfData) return mfData;
    var el = document.getElementById('ps-variant-card-mf');
    if (!el) return null;
    try { mfData = JSON.parse(el.textContent); } catch (e) {
      console.error('[ps-vc-mf] JSON parse FAILED:', e.message);
      console.error('[ps-vc-mf] raw (first 500):', el.textContent.trim().slice(0, 500));
    }
    return mfData;
  }

  function getFirstGalleryImg() {
    return document.querySelector(
      'media-gallery slideshow-slide:first-of-type .product-media img,' +
      'media-gallery slideshow-slide:first-child .product-media img'
    );
  }

  function getTitleEls() {
    var els = Array.from(document.querySelectorAll('[data-ps-card-title]'));
    var h1 = document.querySelector('[data-testid="product-information-details"] h1');
    if (h1 && els.indexOf(h1) === -1) els.push(h1);
    return els;
  }

  function getOrCreateTestimonialEl() {
    var el = document.getElementById('ps-vc-testimonial');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'ps-vc-testimonial';
    el.hidden = true;

    // 1. Avant le variant-picker — juste sous le titre "Configurez votre serre"
    var vp = document.querySelector('.product-details variant-picker');
    if (!vp) vp = document.querySelector('variant-picker');
    if (vp && vp.parentNode) {
      vp.parentNode.insertBefore(el, vp);
      return el;
    }

    // 2. Après ps-pack-cards si présent
    var packCards = document.getElementById('ps-pack-cards');
    if (packCards && packCards.parentNode) {
      packCards.parentNode.insertBefore(el, packCards.nextSibling);
      return el;
    }

    // 3. Ancre dédiée dans la colonne product-details (fallback)
    var anchor = document.getElementById('ps-variant-testimonial-anchor');
    if (anchor) {
      anchor.parentNode.insertBefore(el, anchor);
      return el;
    }

    // 4. Fallback après add-to-cart-component
    var atc = document.querySelector('add-to-cart-component');
    if (atc && atc.parentNode) {
      atc.parentNode.insertBefore(el, atc.nextSibling);
      return el;
    }

    // 5. Retry si rien n'est monté encore
    setTimeout(function () {
      var vp2 = document.querySelector('.product-details variant-picker') || document.querySelector('variant-picker');
      var pc = document.getElementById('ps-pack-cards');
      var a2 = document.getElementById('ps-variant-testimonial-anchor');
      var a3 = document.querySelector('add-to-cart-component');
      if (!document.getElementById('ps-vc-testimonial')) {
        if (vp2) vp2.parentNode.insertBefore(el, vp2);
        else if (pc) pc.parentNode.insertBefore(el, pc.nextSibling);
        else if (a2) a2.parentNode.insertBefore(el, a2);
        else if (a3) a3.parentNode.insertBefore(el, a3.nextSibling);
      }
    }, 800);

    return el;
  }

  function injectCss() {
    if (document.getElementById('ps-vc-css')) return;
    var s = document.createElement('style');
    s.id = 'ps-vc-css';
    s.textContent = [
      '.ps-vc-testimonial{display:flex;align-items:center;gap:.55rem;background:rgba(255,255,255,.55);',
      'backdrop-filter:blur(4px);border-radius:10px;padding:.4rem .75rem;',
      'box-shadow:0 1px 4px rgba(0,0,0,.05);margin-block:-18px}',
      '.ps-vc-t-avatar{width:40px;height:40px;border-radius:50%;overflow:hidden;flex-shrink:0}',
      '.ps-vc-t-avatar img{width:100%;height:100%;object-fit:cover;display:block}',
      '.ps-vc-t-content{display:flex;flex-direction:column;gap:.15rem;flex:1;min-width:0}',
      '.ps-vc-t-quote{font-size:.82rem;line-height:1.45;font-style:italic;color:#1f3d2b;margin:0;overflow-wrap:break-word}',
      '.ps-vc-t-author{font-size:.72rem;color:rgba(1,47,32,.45);font-weight:500}',
      '#ps-summary-testimonial{margin-top:12px}',
      '@media(min-width:750px){.ps-configurator-summary__selection-area{display:grid;grid-template-columns:1fr auto;column-gap:24px;align-items:center}#ps-summary-testimonial{margin-top:0;max-width:320px}.ps-br-testimonial{padding:.7rem 1rem;gap:.7rem;border-radius:12px}.ps-br-t-avatar{width:52px;height:52px}.ps-br-t-quote{font-size:.85rem}.ps-br-t-author{font-size:.74rem}}',
      '@media(max-width:749px){#ps-summary-testimonial{margin-top:12px}}',  
      '.ps-br-testimonial{display:flex;align-items:center;gap:.45rem;background:rgba(0,0,0,.03);border-radius:8px;padding:.35rem .6rem}',
      '.ps-br-t-avatar{width:34px;height:34px;border-radius:50%;overflow:hidden;flex-shrink:0}',
      '.ps-br-t-avatar img{width:100%;height:100%;object-fit:cover;display:block}',
      '.ps-br-t-content{display:flex;flex-direction:column;gap:.08rem}',
      '.ps-br-t-quote{font-size:.72rem;line-height:1.4;font-style:italic;color:#1f3d2b;margin:0}',
      '.ps-br-t-author{font-size:.64rem;color:rgba(1,47,32,.45);font-weight:500}'
    ].join('');
    document.head.appendChild(s);
  }



  var _lastTestimonial = null;

  function buildTestimonialHTML(t, avatarSize) {
    if (!t || !t.quote) return '';
    var shortQuote = t.quote.split('.')[0] + '.';
    var cls = avatarSize === 'sm' ? 'ps-br' : 'ps-vc';
    var sz = avatarSize === 'sm' ? 34 : 40;
    var html = '<div class="' + cls + '-testimonial">';
    if (t.avatar) html += '<div class="' + cls + '-t-avatar"><img src="' + t.avatar + '" alt="" width="' + sz + '" height="' + sz + '" loading="lazy"></div>';
    html += '<div class="' + cls + '-t-content">';
    html += '<p class="' + cls + '-t-quote">' + shortQuote + '</p>';
    if (t.location) html += '<span class="' + cls + '-t-author">Usage &middot; ' + t.location + '</span>';
    html += '</div></div>';
    return html;
  }

  function applySummaryTestimonial(t) {
    var summaryTesti = document.getElementById('ps-summary-testimonial');
    if (!summaryTesti) return;
    // N'afficher que si un bundle est présent sur la page
    if (!document.querySelector('.bundle-reco, [data-bundle-open-offre]')) {
      summaryTesti.hidden = true;
      summaryTesti.innerHTML = '';
      return;
    }
    var bHtml = buildTestimonialHTML(t, 'sm');
    if (bHtml) { summaryTesti.innerHTML = bHtml; summaryTesti.hidden = false; }
    else { summaryTesti.hidden = true; summaryTesti.innerHTML = ''; }
  }
  window.__psApplySummaryTestimonial = function () {
    if (_lastTestimonial) applySummaryTestimonial(_lastTestimonial);
  };

  function applyCard(variantId) {
    var data = loadData();
    if (!data) return;
    var vd = data[String(variantId)] || {};

    // 1. Titre
    var titleEls = getTitleEls();
    if (origTitle === null && titleEls.length) origTitle = titleEls[0].textContent.trim();
    var newTitle = vd.card_title || origTitle || '';
    titleEls.forEach(function (el) { el.textContent = newTitle; });

    // 2. Première image galerie
    var firstImg = getFirstGalleryImg();
    if (firstImg) {
      if (origImgSrc === null) {
        origImgSrc = firstImg.src;
        origImgSrcset = firstImg.srcset || '';
      }
      if (vd.card_image) {
        firstImg.src = vd.card_image;
        firstImg.srcset = '';
        hasCustomImg = true;
      } else if (hasCustomImg) {
        // Seulement restaurer si on avait appliqué une image custom
        firstImg.src = origImgSrc;
        firstImg.srcset = origImgSrcset;
        hasCustomImg = false;
      }
      // Sinon laisser le thème gérer l'image du variant
    }

    // 3. Hidden input pour la line item property panier
    var cardTitleProp = document.getElementById('ps-card-title-prop');
    if (vd.card_title) {
      if (!cardTitleProp) {
        cardTitleProp = document.createElement('input');
        cardTitleProp.type = 'hidden';
        cardTitleProp.name = 'properties[_card_title]';
        cardTitleProp.id = 'ps-card-title-prop';
        var productForm = document.querySelector('product-form-component form');
        if (productForm) productForm.appendChild(cardTitleProp);
      }
      cardTitleProp.value = vd.card_title;
    } else {
      if (cardTitleProp) cardTitleProp.remove();
    }

    // 4. Témoignage — live script (rendu serveur dans le block, résout metaobject_reference via .value)
    // Ne pas créer/afficher le testimonial si pas de bundle sur la page
    if (_hasBundle) {
      var container = getOrCreateTestimonialEl();
      var liveEl = document.getElementById('ps-variant-testimonial-live');
      var live = null;
      if (liveEl && liveEl.dataset.variantId === String(variantId)) {
        try { live = JSON.parse(liveEl.textContent); } catch (e) {}
      }
      var t = (live && live.quote) ? live : (vd.card_testimonial || {});
      _lastTestimonial = t.quote ? t : null;

      if (t.quote) {
        container.innerHTML = buildTestimonialHTML(t, 'lg');
        container.hidden = false;
      } else {
        container.hidden = true;
        container.innerHTML = '';
      }
    } else {
      var t = (vd.card_testimonial || {});
      _lastTestimonial = null;
    }

    // Mini testimonial dans la carte VOTRE SÉLECTION
    applySummaryTestimonial(t);
    if (!document.getElementById('ps-summary-testimonial')) {
      (function (savedT) { setTimeout(function () { applySummaryTestimonial(savedT); }, 300); })(t);
    }
  }

  function init() {
    _hasBundle = !!document.querySelector('.bundle-reco, [data-bundle-open-offre]');
    if (!_hasBundle) {
      var confTitle = document.querySelector('.text-block--AQ2QrRENrMFN3czZPd__configurator_title_block');
      if (confTitle) confTitle.remove();
      var vcTesti = document.getElementById('ps-vc-testimonial');
      if (vcTesti) vcTesti.remove();
    }

    var data = loadData();
    if (!data) return;
    injectCss();

    // Priorité 1 : variant rendu serveur (data-variant-id sur le script live du block)
    var liveEl = document.getElementById('ps-variant-testimonial-live');
    var liveVid = liveEl && liveEl.dataset.variantId;
    if (liveVid && data[liveVid]) { applyCard(liveVid); }
    // Priorité 2 : variant dans l'URL (?variant=ID)
    else { var urlVid = new URLSearchParams(window.location.search).get('variant');
    if (urlVid && data[urlVid]) { applyCard(urlVid); }
    else {
      // Priorité 2 : radio coché avec data-variant-id
      var checked = document.querySelector('.variant-picker__form input[type="radio"]:checked');
      if (checked && checked.dataset.variantId) {
        applyCard(checked.dataset.variantId);
      } else {
        // Priorité 3 : premier variant du JSON
        var firstVid = Object.keys(data)[0];
        if (firstVid) applyCard(firstVid);
      }
    }}
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.variant-picker__form')) return;
      // data-variant-id : disponible sur produit mono-option
      var vid = e.target.dataset && e.target.dataset.variantId;
      if (vid) { applyCard(vid); return; }
      // Fallback : le picker met à jour ?variant= de façon async via yieldToMainThread
      setTimeout(function () {
        var urlVid = new URLSearchParams(window.location.search).get('variant');
        if (urlVid && data[urlVid]) applyCard(urlVid);
      }, 0);
    });

    // variant:update — après rendu serveur, contient le vrai variant ID
    document.addEventListener('variant:update', function (e) {
      var vid = e && e.detail && e.detail.resource && e.detail.resource.id;
      if (vid) applyCard(String(vid));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =====================================================
   Upsell intelligent — upgrade variant
   Condition : dernier groupe d'options a 2 choix,
   et le variant sélectionné n'est pas le plus cher.
   Déclenché à l'interception du clic ATC.
   ===================================================== */
(function () {
  var _upsellShown = false;

  function _fmt(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}}\u00a0\u20ac';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var zeroDec = ['JPY','KRW','VND'];
    var prec = zeroDec.indexOf(cur.toUpperCase()) !== -1 ? 0 : 2;
    var div = Math.pow(10, prec);
    return fmt.replace(/{{\s*(\w+)\s*}}/g, function (_, ph) {
      var t = ',', d = '.', p = prec;
      if (ph === 'amount_no_decimals') p = 0;
      else if (ph === 'amount_with_comma_separator') { t = '.'; d = ','; }
      else if (ph === 'amount_no_decimals_with_comma_separator') { t = '.'; p = 0; }
      var n = (cents / div).toFixed(p);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\d(?=(\d{3})+(?!\d))/g, '$&' + t);
      return p <= 0 ? parts[0] : parts[0] + d + (parts[1] || '').padEnd(p, '0');
    });
  }

  function _getPriceCache() {
    var script = document.querySelector('variant-picker script[data-ps-variant-prices]');
    if (!script) return {};
    var cache = {};
    try {
      JSON.parse(script.textContent).forEach(function (v) {
        cache[String(v.id)] = { price: v.price };
      });
    } catch (e) {}
    return cache;
  }

  function _getProductPopup() {
    var script = document.querySelector('variant-picker script[data-ps-product-popup]');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch (e) { return {}; }
  }

  function getUpsellData() {
    var fieldsets = Array.from(document.querySelectorAll('.variant-picker__form .variant-option--buttons'));
    if (!fieldsets.length) return null;
    var lastFieldset = fieldsets[fieldsets.length - 1];
    var radios = Array.from(lastFieldset.querySelectorAll('input[type="radio"][data-variant-id]'));
    if (radios.length < 2) return null;

    console.log('[ps-upsell] Checking upsell for last option group with ' + radios.length + ' options');
    var cache = _getPriceCache();
    var pp = _getProductPopup();
    var options = radios.map(function (radio) {
      var vid = String(radio.dataset.variantId);
      var labelEl = lastFieldset.querySelector('label[for="' + radio.id + '"] .variant-option__button-label__text')
        || lastFieldset.querySelector('label[for="' + radio.id + '"]');
      return {
        radio: radio,
        variantId: vid,
        price: (cache[vid] || { price: 0 }).price,
        label: labelEl ? labelEl.textContent.trim() : radio.value,
        checked: radio.checked,
        popupBadge: pp.badge || null,
        popupTitle: pp.title || null,
        popupSubtitle: pp.subtitle || null,
        popupCta: pp.cta || null,
        popupDeclineText: pp.decline || null
      };
    });

    var currentIdx = options.findIndex(function (o) { return o.checked; });
    if (currentIdx === -1) return null;
    var current = options[currentIdx];

    // Prendre uniquement le variant immédiatement au-dessus dans la liste
    var upgrade = null;
    for (var i = currentIdx + 1; i < options.length; i++) {
      if (options[i].price > current.price) { upgrade = options[i]; break; }
    }
    if (!upgrade) return null;

    var legend = lastFieldset.querySelector('legend');
    var optionName = legend ? (legend.childNodes[0] ? legend.childNodes[0].textContent.trim() : legend.textContent.trim()) : '';

    return { optionName: optionName, current: current, upgrade: upgrade, diff: upgrade.price - current.price };
  }

  function injectCSS() {
    if (document.getElementById('ps-upsell-css')) return;
    var s = document.createElement('style');
    s.id = 'ps-upsell-css';
    s.textContent = [
      /* overlay — opacité réduite */
      '.ps-upsell-overlay{position:fixed;inset:0;z-index:100000;display:flex;align-items:flex-end;justify-content:center;background:rgb(var(--color-shadow-rgb,10 20 10)/.36);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);opacity:0;transition:opacity .25s ease}',
      '.ps-upsell-overlay.is-open{opacity:1}',
      '@media(min-width:750px){.ps-upsell-overlay{align-items:center}}',
      /* sheet — padding réduit */
      '.ps-upsell-sheet{background:var(--color-background,#f5f0e8);border-radius:28px 28px 0 0;width:100%;max-width:540px;padding:0 0 1.8rem;box-shadow:0 -8px 48px rgb(var(--color-shadow-rgb,0 0 0)/.18),0 -1px 0 rgb(var(--color-shadow-rgb,0 0 0)/.04);transform:translateY(100%);transition:transform .38s cubic-bezier(.22,1,.36,1)}',
      '@media(min-width:750px){.ps-upsell-sheet{border-radius:24px;transform:translateY(28px) scale(.97);box-shadow:0 24px 64px rgb(var(--color-shadow-rgb,0 0 0)/.18),0 2px 8px rgb(var(--color-shadow-rgb,0 0 0)/.07);opacity:0;transition:transform .38s cubic-bezier(.22,1,.36,1),opacity .25s ease}}',
      '.ps-upsell-overlay.is-open .ps-upsell-sheet{transform:translateY(0) scale(1);opacity:1}',
      '.ps-upsell-close{position:absolute;top:1rem;right:1rem;display:inline-flex;align-items:center;justify-content:center;width:2.75rem;height:2.75rem;border:none;border-radius:999px;background:transparent;color:rgb(var(--color-foreground-rgb,26 36 24)/.78);cursor:pointer;transition:background .2s ease,color .2s ease,transform .2s ease;z-index:2}',
      '.ps-upsell-close:hover{background:rgb(var(--color-foreground-rgb,26 36 24)/.07);color:var(--color-foreground-heading,var(--color-foreground,#1a2418));transform:rotate(90deg)}',
      '.ps-upsell-close svg{width:1.4rem;height:1.4rem;display:block}',
      /* drag handle — moins d\'espace */
      '.ps-upsell-handle{width:36px;height:4px;background:var(--color-border,#ddd8cf);border-radius:2px;margin:.65rem auto .2rem}',
      /* product image — un peu plus grande, moins de blanc sous l\'image */
      '.ps-upsell-product-img{width:84px;height:84px;border-radius:14px;overflow:hidden;margin:.4rem auto .1rem;flex-shrink:0;border:1.5px solid var(--color-border,#ddd8cf)}',
      '.ps-upsell-product-img img{width:100%;height:100%;object-fit:cover;display:block}',
      /* header — moins d\'espace, padding réduit */
      '.ps-upsell-header{padding:.35rem 1.35rem 0}',
      /* badge sans losange, plus petit */
      '.ps-upsell-eyebrow{display:inline-flex;align-items:center;gap:.3rem;font-size:.52rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--color-primary,#012f20);background:rgb(var(--color-primary-rgb,1 47 32)/.1);padding:.2rem .55rem;border-radius:20px;margin-bottom:.6rem}',
      '.ps-upsell-title{font-size:1.3rem;font-weight:800;color:var(--color-foreground-heading,var(--color-foreground,#1a2418));margin-bottom:.2rem;line-height:1.25;letter-spacing:-.025em}',
      /* diff — moins de marge en bas, séparation visuelle avec les cartes */
      '.ps-upsell-diff{font-size:.82rem;color:var(--color-foreground,#4a5545);margin-bottom:.8rem;line-height:1.5;opacity:.75}',
      '.ps-upsell-diff strong{color:var(--color-primary,#012f20);font-weight:800;background:rgb(var(--color-primary-rgb,1 47 32)/.14);padding:.12rem .52rem;border-radius:20px;font-size:.88rem;opacity:1}',
      /* cards — padding horizontal réduit, séparateur visuel au-dessus, CTA plus proche */
      '.ps-upsell-cards{display:grid;grid-template-columns:1fr 1fr;gap:.7rem;margin:0 1.35rem .8rem;padding-top:.75rem;border-top:1px solid var(--color-border,#ddd8cf);align-items:stretch}',
      /* carte inactive moins fade, bordure plus fine */
      '.ps-upsell-card{border:1.5px solid var(--color-border,#ddd8cf);border-radius:18px;padding:.9rem .85rem;display:flex;flex-direction:column;gap:.35rem;cursor:pointer;position:relative;overflow:hidden;transition:border-color .2s,box-shadow .2s,transform .15s;background:var(--color-background,#f5f0e8)}',
      '.ps-upsell-card:hover{transform:translateY(-1px);box-shadow:0 4px 16px rgb(var(--color-shadow-rgb,0 0 0)/.09)}',
      '.ps-upsell-card--current{opacity:.82}',
      '.ps-upsell-card--current:hover{opacity:1}',
      '.ps-upsell-card--upgrade{border-color:var(--color-primary,#012f20);border-width:2px;background:rgb(var(--color-primary-rgb,1 47 32)/.06);box-shadow:0 4px 20px rgb(var(--color-primary-rgb,1 47 32)/.12);opacity:1}',
      '.ps-upsell-card--upgrade:hover{transform:translateY(-2px);box-shadow:0 8px 28px rgb(var(--color-primary-rgb,1 47 32)/.18)}',
      /* check vert plus grand */
      '.ps-upsell-card--upgrade::after{content:"";position:absolute;top:.55rem;right:.6rem;width:1.5rem;height:1.5rem;background:var(--color-primary,#012f20);border-radius:50%}',
      '.ps-upsell-card--upgrade::before{content:"\\2713";position:absolute;top:.55rem;right:.6rem;width:1.5rem;height:1.5rem;z-index:1;color:var(--color-primary-button-text,#fff);font-size:.72rem;font-weight:900;display:flex;align-items:center;justify-content:center;line-height:1.5rem;text-align:center}',
      /* card internals */
      '.ps-upsell-card__tag{font-size:.54rem;font-weight:700;text-transform:uppercase;letter-spacing:.07em;padding:.18rem .52rem;border-radius:20px;align-self:flex-start;line-height:1.4}',
      '.ps-upsell-card--current .ps-upsell-card__tag{background:var(--color-border,#ddd8cf);color:var(--color-foreground,#4a5545);opacity:.8}',
      '.ps-upsell-card--upgrade .ps-upsell-card__tag{background:var(--color-primary,#012f20);color:var(--color-primary-button-text,#fff)}',
      '.ps-upsell-card__name{font-size:.88rem;font-weight:700;color:var(--color-foreground,#4a5545);line-height:1.3;margin-top:.05rem}',
      '.ps-upsell-card--upgrade .ps-upsell-card__name{font-size:.92rem;color:var(--color-primary,#012f20)}',
      '.ps-upsell-card__option{font-size:.63rem;color:var(--color-foreground,#4a5545);text-transform:uppercase;letter-spacing:.05em;font-weight:600;opacity:.5}',
      /* prix inactive plus lisible */
      '.ps-upsell-card__price{font-size:.84rem;color:var(--color-foreground,#4a5545);margin-top:auto;padding-top:.45rem;text-decoration:line-through;opacity:.65}',
      '.ps-upsell-card--upgrade .ps-upsell-card__price{font-size:1.05rem;font-weight:800;color:var(--color-foreground-heading,var(--color-foreground,#1a2418));text-decoration:none;opacity:1}',
      /* actions — padding réduit */
      '.ps-upsell-actions{display:flex;flex-direction:column;gap:.55rem;padding:0 1.35rem}',
      '.ps-upsell-btn-upgrade{background:var(--color-primary-button-background,#012f20);color:var(--color-primary-button-text,#fff);border:none;border-radius:14px;padding:.88rem 1.2rem;font-size:.88rem;font-weight:800;cursor:pointer;width:100%;box-shadow:0 4px 18px rgb(var(--color-primary-rgb,1 47 32)/.28),0 1px 3px rgb(var(--color-shadow-rgb,0 0 0)/.1);transition:background .2s,box-shadow .2s,transform .15s;letter-spacing:.01em}',
      '.ps-upsell-btn-upgrade:hover{background:var(--color-primary-button-hover-background,#1e3418);box-shadow:0 6px 24px rgb(var(--color-primary-rgb,1 47 32)/.36),0 2px 6px rgb(var(--color-shadow-rgb,0 0 0)/.1);transform:translateY(-1px)}',
      '.ps-upsell-btn-upgrade:active{transform:translateY(0)}',
      '.ps-upsell-btn-skip{background:transparent;color:var(--color-foreground,#4a5545);border:none;font-size:.75rem;cursor:pointer;padding:.38rem;transition:opacity .15s;letter-spacing:.01em;opacity:.5}',
      '.ps-upsell-btn-skip:hover{opacity:1}'
    ].join('');
    document.head.appendChild(s);
  }

  function _getFirstCarouselImg() {
    // Try the active/first slide in the carousel first, then fall back to grid
    var img = document.querySelector('.product-media-container img, .media-gallery__grid img');
    return img ? img.currentSrc || img.src : null;
  }

  function showUpsell(data, form) {
    if (_upsellShown) { return; }
    injectCSS();

    var imgSrc = data.imgSrc || _getFirstCarouselImg();
    var imgHtml = imgSrc
      ? '<div class="ps-upsell-product-img"><img src="' + imgSrc + '" alt="" loading="eager" decoding="async"></div>'
      : '';

    var u = data.upgrade;
    var _badge   = u.popupBadge   || 'Avant de continuer';
    var _title   = u.popupTitle   || ('Passer \u00e0 ' + u.label + '\u00a0?');
    var _diff    = u.popupSubtitle || ('Pour seulement <strong>+' + _fmt(data.diff) + '</strong> de plus');
    var _cta     = u.popupCta     || ('Passer \u00e0 ' + u.label + ' (+' + _fmt(data.diff) + ')');
    var _decline = u.popupDeclineText || ('Non merci, continuer avec ' + data.current.label);

    var overlay = document.createElement('div');
    overlay.className = 'ps-upsell-overlay';
    overlay.innerHTML =
      '<div class="ps-upsell-sheet">' +
        '<button class="ps-upsell-close" type="button" data-upsell-close aria-label="Fermer">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="ps-upsell-handle"></div>' +
        imgHtml +
        '<div class="ps-upsell-header">' +
          '<p class="ps-upsell-eyebrow">' + _badge + '</p>' +
          '<p class="ps-upsell-title">' + _title + '</p>' +
          '<p class="ps-upsell-diff">' + _diff + '</p>' +
        '</div>' +
        '<div class="ps-upsell-cards">' +
          '<div class="ps-upsell-card ps-upsell-card--current" data-upsell-choose="current">' +
            '<span class="ps-upsell-card__tag">Ma s\u00e9lection</span>' +
            '<span class="ps-upsell-card__name">' + data.current.label + '</span>' +
            (data.optionName ? '<span class="ps-upsell-card__option">' + data.optionName + '</span>' : '') +
            '<span class="ps-upsell-card__price">' + _fmt(data.current.price) + '</span>' +
          '</div>' +
          '<div class="ps-upsell-card ps-upsell-card--upgrade" data-upsell-choose="upgrade">' +
            '<span class="ps-upsell-card__tag">Meilleur choix</span>' +
            '<span class="ps-upsell-card__name">' + u.label + '</span>' +
            (data.optionName ? '<span class="ps-upsell-card__option">' + data.optionName + '</span>' : '') +
            '<span class="ps-upsell-card__price">' + _fmt(u.price) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="ps-upsell-actions">' +
          '<button class="ps-upsell-btn-upgrade" data-upsell-choose="upgrade">' + _cta + '</button>' +
          '<button class="ps-upsell-btn-skip" data-upsell-choose="current">' + _decline + '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });

    function close(chosenUpgrade) {
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.remove(); }, 300);
      _upsellShown = false;
      if (chosenUpgrade) {
        // Set variant ID directly BEFORE submit — no change event yet (avoids #variantChangeInProgress race)
        var variantInput = form.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = data.upgrade.variantId;
        if (data.current.radio) data.current.radio.checked = false;
        if (data.upgrade.radio) data.upgrade.radio.checked = true;
      }
      // Single requestSubmit — handleSubmit starts with variantChangeInProgress=false → one fetch
      form.requestSubmit ? form.requestSubmit() : form.submit();
      if (chosenUpgrade && data.upgrade.radio) {
        // Dispatch change AFTER submit so the UI (URL, price, images) updates — no second add triggered
        data.upgrade.radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _upsellShown = true;
    overlay.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-choose]');
      var closeBtn = e.target.closest('[data-upsell-close]');
      if (closeBtn) { close(false); return; }
      if (!btn && !e.target.closest('.ps-upsell-sheet')) { close(false); return; }
      if (!btn) return;
      close(btn.dataset.upsellChoose === 'upgrade');
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { close(false); document.removeEventListener('keydown', onKey); }
    });
  }

  function init() {
    var mainEl = document.querySelector('main[data-template]');
    if (!mainEl || !mainEl.getAttribute('data-template').startsWith('product')) return;

    var ATC_SELECTOR = [
      'add-to-cart-component button[ref="addToCartButton"]',
      'add-to-cart-component button[type="submit"]',
      '.sticky-add-to-cart__button'
    ].join(', ');

    function interceptClick(e) {
      var btn = e.target.closest(ATC_SELECTOR);
      if (!btn) return;
      if (btn.className.includes('bundle-card__cta')) return;
      if (btn.closest('.offre-acc') || btn.closest('.bundle-reco-modal')) return;

      // Cross-sell card upsell — utilise les variants du produit cross-sell
      var csCard = btn.closest('[data-ps-product-id]');
      if (csCard) {
        var productId = csCard.dataset.psProductId;
        var csDataEl = document.getElementById('ps-cross-sell-data');
        if (csDataEl) {
          var csProducts;
          try { csProducts = JSON.parse(csDataEl.textContent.trim()); } catch (_) {}
          if (csProducts) {
            var csProduct = csProducts.find(function (p) { return String(p.id) === String(productId); });
            if (csProduct && csProduct.variants && csProduct.variants.length >= 2) {
              var formComponent = csCard.querySelector('product-form-component');
              var csForm = formComponent && formComponent.querySelector('form[action^="/cart/add"]');
              if (csForm) {
                var csVariantInput = csForm.querySelector('input[name="id"]');
                var currentVid = csVariantInput ? String(csVariantInput.value) : String(csProduct.variant_id);
                var csVariants = csProduct.variants;
                var currentVariant = csVariants.find(function (v) { return String(v.id) === currentVid; }) || csVariants[0];
                var csUpgrade = null;
                for (var vi = 0; vi < csVariants.length; vi++) {
                  if (csVariants[vi].price > currentVariant.price) {
                    if (!csUpgrade || csVariants[vi].price < csUpgrade.price) csUpgrade = csVariants[vi];
                  }
                }
                if (csUpgrade) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  e.stopPropagation();
                  var csImg = csCard.querySelector('.ps-cs-card__img');
                  showUpsell({
                    imgSrc: csImg ? csImg.src : null,
                    optionName: '',
                    current: { variantId: String(currentVariant.id), price: currentVariant.price, label: currentVariant.title, radio: null },
                    upgrade: { variantId: String(csUpgrade.id), price: csUpgrade.price, label: csUpgrade.title, radio: null, popupBadge: null, popupTitle: null, popupSubtitle: null, popupCta: null, popupDeclineText: null },
                    diff: csUpgrade.price - currentVariant.price
                  }, csForm);
                  return;
                }
              }
            }
          }
        }
        // No upsell for this cross-sell product — let click through
        return;
      }

      var data = getUpsellData();
      if (!data) return;

      // Bloque click + animation thème + form submit naturel — TOUT
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      // Retrouver le form AVANT d'afficher la popup
      var form = btn.closest('form[action^="/cart/add"]')
        || btn.closest('product-form-component')?.querySelector('form[action^="/cart/add"]')
        || document.querySelector('form[action^="/cart/add"]');

      if (!form) return;

      // Pass form directly so close() can set input[name="id"] before submitting
      showUpsell(data, form);
    }

    if (!document._psUpsellBound) {
      document._psUpsellBound = true;
      // capture:true = s'exécute AVANT tous les listeners bubble du thème
      document.addEventListener('click', interceptClick, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ===== Klarna — déplacer sous le bloc téléphone sur desktop =====
(function () {
  function moveKlarnaOnDesktop() {
    if (window.innerWidth < 750) return;
    if (document.querySelector('[data-ps-klarna-moved]')) return;
    var klarna = document.querySelector('[data-ps-klarna]');
    if (!klarna) return;
    var phoneLink = document.querySelector('a[href^="tel:"]');
    if (!phoneLink) return;
    // Trouver le <p> ou le premier ancêtre bloc contenant le lien tel:
    var phonePara = phoneLink.closest('p') || phoneLink.parentElement;
    if (!phonePara || !phonePara.parentNode) return;
    phonePara.parentNode.insertBefore(klarna, phonePara.nextSibling);
    klarna.setAttribute('data-ps-klarna-moved', '1');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveKlarnaOnDesktop);
  } else {
    moveKlarnaOnDesktop();
  }
})();

// ===== Checkmarks — split sur mobile =====
(function () {
  function splitCheckmarks() {
    if (window.innerWidth >= 750) return;
    var paragraphs = document.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i++) {
      var p = paragraphs[i];
      if (!p) continue;
      var text = p.textContent || '';
      var count = (text.match(/✓/g) || []).length;
      if (count < 2) continue;
      var raw = p.innerHTML;
      var parts = raw.split(/\s*·\s*(?=✓)/);
      if (parts.length < 2) {
        parts = raw.split(/\s+(?=✓[^])/);
      }
      if (parts.length < 2) continue;
      p.innerHTML = parts.map(function (part) {
        return '<span class="ps-check-item">' + part.trim() + '</span>';
      }).join('');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitCheckmarks);
  } else {
    splitCheckmarks();
  }
})();
